"use strict";
exports.__esModule = true;
exports.default = {
  el: {
    colorpicker: {
      confirm: "确定",
      clear: "清空"
    },
    datepicker: {
      now: "此刻",
      today: "今天",
      cancel: "取消",
      clear: "清空",
      confirm: "确定",
      selectDate: "选择日期",
      selectTime: "选择时间",
      startDate: "开始日期",
      startTime: "开始时间",
      endDate: "结束日期",
      endTime: "结束时间",
      year: "年",
      month1: "1 月",
      month2: "2 月",
      month3: "3 月",
      month4: "4 月",
      month5: "5 月",
      month6: "6 月",
      month7: "7 月",
      month8: "8 月",
      month9: "9 月",
      month10: "10 月",
      month11: "11 月",
      month12: "12 月",
      // week: '周次',
      weeks: {
        sun: "日",
        mon: "一",
        tue: "二",
        wed: "三",
        thu: "四",
        fri: "五",
        sat: "六"
      },
      months: {
        jan: "一月",
        feb: "二月",
        mar: "三月",
        apr: "四月",
        may: "五月",
        jun: "六月",
        jul: "七月",
        aug: "八月",
        sep: "九月",
        oct: "十月",
        nov: "十一月",
        dec: "十二月"
      }
    },
    select: {
      loading: "加载中",
      noMatch: "无匹配数据",
      noData: "无数据",
      placeholder: "请选择"
    },
    cascader: {
      noMatch: "无匹配数据",
      loading: "加载中",
      placeholder: "请选择"
    },
    pagination: {
      goto: "前往",
      pagesize: "条/页",
      total: "共 {total} 条",
      pageClassifier: "页"
    },
    mypagination: {
      total: "共",
      tiao: '条',
      next: '下一页',
      prev: '上一页'

    },
    messagebox: {
      title: "提示",
      confirm: "确定",
      cancel: "取消",
      error: "输入的数据不合法!"
    },
    upload: {
      delete: "删除",
      preview: "查看图片",
      continue: "继续上传"
    },
    table: {
      emptyText: "暂无数据",
      confirmFilter: "筛选",
      resetFilter: "重置",
      clearFilter: "全部",
      sumText: "合计"
    },
    tree: {
      emptyText: "暂无数据"
    },
    transfer: {
      noMatch: "无匹配数据",
      noData: "无数据",
      titles: ["列表 1", "列表 2"],
      filterPlaceholder: "请输入搜索内容",
      noCheckedFormat: "共 {total} 项",
      hasCheckedFormat: "已选 {checked}/{total} 项"
    }
  },
  share: {
    year: "年",
    month: '月',
    day1:'日',
    day: '天',
    hour: '小时',
    minutes: '分钟',
    seconds: '秒',
    download: '下载',
    upload: '上传',
    english: '英文',
    chinese: '中文',
    logLevel: "日志等级",
    unassigned1: "未分配",
    assigned1: "已分配",
    all: "全部",
    unassigned: "未分配",
    assigned: "已分配",
    queryMac: "按MAC地址搜索",
    autoAssign: "自动分配",
    clone: "克隆",
    close: "关闭",
    add: "新增",
    mod: "修改",
    del: "删除",
    save: "保存",
    cue: "提示",
    confirm: "确定",
    cancel: "取消",
    delConfirm: "此操作将永久删除，是否继续？",
    cancelDel: "已取消删除",
    select: "请选择",
    search: "搜索",
    refreshOk: "刷新成功",
    getFile: "获取文件",
    fileName: "文件名",
    selectFile: "请选择导入文件",
    upFile: "点击获取文件后选择需要上传的文件",
    import: "导入",
    export: "导出",
    refresh: "刷新",
    inputPw: "请输入密码",
    inputOldPw: "请输入旧密码",
    oldPassErr: "旧密码验证失败",
    inputConfirmPw: "请输入确认密码",
    confirmPwErr: "两次输入密码不一致",
    uploadOk: "上传成功",
    uploadFail: "上传失败",
    info: "详情",
    selectDate: "选择日期时间",
    searchType: "请选择搜索方式",
    status: "状态",
    suc: "成功",
    fail: "失败",
    enable: "启用",
    canceled: "已取消",
    all: "全部",
    default: "默认",
    "default1": "默认",
    check: "查看",
     checktoken: "查看token",
    ops: "操作成功",
    opf: "操作失败",
    inprogress: "同步中",
    titleDes: "设置云账号，云平台设备可以通过你的云账号同步导入到网管进行管理。",
    domainDes: "域是网管系统设备列表的根目录，作为每个设备的唯一归属区域。",
    next: "下一步",
    changeStatus: "确定要改变状态？",
    delData: "此操作将永久删除,并且删除此设备呼叫监控数据，是否继续？",
    operation: '操作',
    return: '返回',
    required: '必填',
    operationCode: '操作码：'
  },
  login: {
    productName: "设备统一管理系统",
    username: "用户名",
    password: "密码",
    titleName: "UMS",
    copyright: "上海迅时通信设备有限公司 2026，保留一切权利。",
    login_btn: "登录",
    login_errormsg: "登录失败",
    remeberMe: "记住我",
    retry: "您还可以尝试登录 {time} 次",
    versions: "系统组件版本",
    release: "Release：",
    web: "web 版本：",
    ums: "UMS 版本：",
    umsDevice: "umsdevice 版本：",
    err:'未授权：证书无效或过期',
  },
  menu: {
    mini: "UMS",
    monitorPage:'监控页面',
    monitorPage_screen:'监控大屏',
    monitorPage_device:'设备监控',
    device: "设备",
    device_list: "设备列表",
    device_config: "设备配置",
    device_status: "设备状态",
    device_upgrade: "设备升级",
    device_deploy: "部署管理",
    management: "管理",
    management_group: "设备组",
    management_model: "模板",
    management_model_om: "OM模板",
    management_model_mx: "MX模板",
    management_model_voip: "模板列表",
    management_config_voip: "配置管理",
    management_phoneSource: "号码资源",
    management_model_file: "配置克隆",
    management_package: "升级包",
    management_parameter: "参数",
    management_parameter_mx: "MX参数",
    management_parameter_om: "OM参数",
    management_parameter_voip: "参数列表",
    management_user: "用户",
    management_privilege: "角色",
    management_log: "操作日志",
    monitor: "监控告警",
    alarm: "警报",
    monitoring: "监控",
    event: "事件",
    task: "任务列表",
    system: "系统设置",
    domain: "域设置",
    cloud: "云账号设置",
    secr: "云账号",
    sysinfo: "系统信息",
    dataBackup: "数据维护",
    alarmSet: "告警事件设置",
    ignoreAlarm: "忽略未知告警事件",
    ignoreAlarm_note: "开启‘忽略未知告警事件’功能，系统将不再记录监控未知告警事件",
    emailSet: "邮件服务器设置",
    phoneSet: "电话服务设置",
    emailAddr: "邮件服务器地址",
    emailUser: "账号",
    emailPass: "密码",
    emailLang: "邮件内容语言",
    emailsubject:"邮件主题",
    emailSet_note: "请填写用来发送告警通知的邮件服务器信息",
    devicePassSet: "设备默认密码设置",
    devPass: "密码",
    setDevicePassOk: "设备默认密码设置成功",
    setEmailOk: "邮件服务器设置成功",
    setPhoneOk: "电话服务设置成功",
    setIgnoreAlarmOk: "忽略未知告警事件功能设置成功",
    emailSecurity: "连接安全",
    direct_sell: "直销管理",
    device_maintenance: "维护诊断",
    sys_alarm: "系统告警",
    bigScreenConfigure: '大屏配置',

  },
  index: {
    week:'弱',
    meddle:'中',
    strong:'强',
    changePassTitle: "修改密码",
    changePassNote: "账号登录密码为初始默认密码，为了系统安全，请修改账号登录密码。",
    oldPass: "原始密码",
    newPass: "新密码",
    newPassValid1: "密码必须是8-16位的数字大小写字母符号至少三种的组合",
    newPassValid2: "密码必须是8-16位",
    confirmNewPass: "确认密码",
    securitySet: "安全设置",
    allowLogin: "允许登录IP地址",
    ipStart: "起始 IP",
    ipStartCue: "请输入起始地址",
    ipCue: "请输入正确的IP地址",
    ipEnd: "结束 IP",
    description: "描述",
    createTime: "创建时间",
    IllegalLogin: "非法登录IP地址",
    deadLine: "有效期",
    allowLoginTitle: "请输入允许登录IP地址",
    "user-defined": "自定义",
    myIP: "我的IP",
    anyIP: "任意IP",
    news: "最新消息",
    newDevice: "有 {count} 台新设备上线啦！",
    license: "license 剩余 {day} 天过期！",
    licenseExpirese: "license 已过期！",
    sysadmin: "超级管理员",
    admin: "管理员",
    logout: "退出登录",
    changePwOk: "修改密码成功",
    secGroupAddOk: "添加成功",
    secGroupModOk: "修改成功",
    secGroupDelOk: "删除成功",
    userInfo: "个人信息",
    changeUserInfo: "修改个人信息",
    changeUserInfoOK: "修改个人信息成功",
    OMAdress: "OM设备地址",
    apiPass: "服务密码",
    exdID: "分机号",
    menuID: "菜单号",
    lineType: "电话服务提供商",
    defaultLine: "迅时电话服务",
    userCreate: "自建服务",
    testInform: "保存成功后，您可以在此输入一个邮箱用以测试您的设置",
    sendEmail: "发送测试邮件",
    testOk: "测试邮件发送成功，请查收您的邮箱",
    none: "无",
    newVersion: "有可升级的新版本{version}！",
    testFail: "邮件测试失败",
    inTesting: "测试中"
  },
  ipphoneConfig: {
    add: "新增配置文件",
    name: "配置文件名称",
    time: "创建时间",
    templateName: "模版名称",
    userId: "创建人",
    pType: "产品类型",
    IpphonepType: '话机类型',
    file: "配置文件",
    remark: "备注",
    configContent: "配置文件内容",
    required: "必填",
    fileSize: "文件大小",
    modify: "修改",
    selectUseLine: "选择配置生效线路：",
    sysLog: '系统日志',
    telphoneSet: '电话设置',
    line: '线路',
    voiceCode: '语音编码'

  },
  phoneSource: {
    phone: "号码",
    mac: "mac地址",
    password: "密码",
    downTemplate: "模版下载",
    required: "必填",
    confirmChangeStatue: "确定要改变自动分配状态？",
    cancelChange: "已取消更改",
    macError: "mac地址格式错误",
  },
  setDeploy: {
    stotal: "总数",
    sRerty: '重试',
    complete: '完成',
    configContent: '配置内容',
    configNull: '配置为空',
    notRunning: "未执行",
    runningTotal: "执行中/总数",
    running: "执行中",
    notStarted: "未启动",
    success: "成功",
    failed: "失败",
    doneTotal: "已完成/总数",
    configFilename: "配置文件名称",
    startTask: "确定要启动此任务吗？",
    stopTask: "确定要停止此任务吗？",
    cancelTask: "确定要取消此任务吗？",
    start: "启动",
    stop: "停止",
    cancel: "取消",
    selectGroup: "选择分组",
    confirm: "确定",
    cancel: "取消",
    concurrentTasks: "任务并发数",
    select: "选择日期时间",
    please: "请选择",
    yes: "是",
    no: "否",
    tab1: "任务详情",
    tab2: "手动部署",
    tab3: "自动部署",
    add1: "创建手动部署任务",
    add2: "创建自动部署任务",
    timeTask: "定时任务",
    manualTime: "定时时间",
    addType: "选择设备",
    addType1: "按组部署",
    addType2: "按设备部署",
    taskName: "任务名称",
    remark: "备注",
    config: "配置文件",
    updatePackage: "升级包",
    deviceType: "设备型号",
    assignPhone: "号码分配",
    type: "类型",
    task1: "手工任务",
    task2: "自动任务",
    time: "定时",
    tableTime: "启动时间",
    taskProgress: "任务状态",
    taskStatus: "任务状态",
    oper: "操作",
    downConfig: "下发配置",
    versionUpdate: "版本升级",
    phoneAssign: "号码分配",
    taskTime: "时间",
    createTime: "创建时间",
    dTime: "部署时间",
    create: "创建",
    mac: "MAC",
    group: "分组",
    setDeployMsg1: '请至少选择配置，升级包，分配号码中的一项任务',
    selectDeviceGroup: '请至少选择一个设备组',
    selectDeviceOne: '请至少选择一个设备',
    deviceNum100: '不能选择超过100台设备',

  },
  numberSource: {
    number: "号码",
    mac: "MAC地址",
    assignAt: "分配时间",
    assignStatus: "分配状态"
  },
  device: {
    appVersion: "app版本",
    kernelVersion: "kernel版本",
    Unknown: "未知",
    cancel: "取消",
    confirm: "确定",
    ip2: "设备IP",
    alarms: "警报列表",
    model: "型号",
    eventList: "事件列表",
    lineStatus: "线路状态",
    all: "所有设备",
    cloud: "云账号{cloudid}扫描",
    auto: "自动发现",
    manual: "手动添加",
    name: "设备名称",
    mac: "设备 MAC",
    proType: "设备型号",
    group: "设备组",
    groupBtn: "组",
    selectGroup: "请选择设备组",
    selecttype:"请选择设备型号",
    addr: "安装地址",
    addrCue: "请输入设备安装地区信息",
    ip: "访问地址",
    ipCue: "例如：http://220.123.156.45",
    pw: "密码",
    oldPw: "旧密码",
    confirmPw: "确认密码",
    contacts: "联系人",
    contactsCue: "请输入联系人手机或座机号码",
    status: {
      label: "状态",
      online: "在线",
      offline: "离线",
      forbidden: "受限",
      abnormal: "设备MAC地址错误",
      fault: "设备故障",
      unreachable: "设备不可达",
      wrongPw: "设备密码配置错误",
      locked: "设备被锁定",
      firstOnline: "第一次上线时间:",
      lastOnline: "最后一次上线时间:",
      lastOffline: "最后一次离线时间:",
      forbiddenNote: "请将网管 IP 添加到云平台安全组"
    },
    addGroupS: "添加设备组成功",
    modGroupS: "修改设备组成功",
    delGroupS: "删除设备组成功",
    selectCue: "请先选择设备",
    inputGroup: "请输入设备组名称",
    inputGroupRule: "请输入2-10位任意字符",
    import: "导入",
    importFile: "请选择导入文件",
    addDev: "请输入设备信息",
    delDevOk: "设备删除成功",
    addDevOk: "添加设备成功",
    modDevOk: "修改设备成功",
    inputDevName: "请输入设备名称",
    inputDevMac: "请输入设备 MAC",
    inputIp: "请输入完整URL格式的访问IP",
    validFail: "您输入的设备信息不符合要求,请重新输入",
    queryCloud: "发现云平台设备，点击+可以添加设备到网管",
    updateGroupOk: "设备组更新成功",
    updateGroupFail: "设备组更新失败，失败信息：",
    basicInfo: "基本信息",
    selectLine: "请先选择一条记录！",
    editGroup: "修改设备组名称",
    exportPass: "是否导出设备的密码",
    tag1: "标签1",
    tag2: "标签2",
    tag3: "标签3",
    inputTag: "请输入标签",
    userDefined: '自定义',
    noEdite: '不修改',
    null: "置空",
    selectMode: '请选择',
    validPass: '密码不一致',
    importTemplate: '导入模板'
  },
  devConf: {
    selectByList: "按设备选择",
    selectByGroup: "按设备组选择",
    accessFail: "设备不在线或设备密码配置不正确",
    importTarCue: "请选择导入TAR包",
    confTar: "配置包",
    uploadBackTar: "上传备份包",
    createFileTmp: "创建文件模板",
    backTime: "备份时间",
    setTimes: "下发次数",
    setTime: "下发时间",
    setResult: "下发结果",
    setConf: "下发配置",
    set: "下发",
    confirm: "确认已经备份了最新配置，配置下发后将不可恢复，是否继续？",
    setOk: "配置下发成功",
    setFail: "配置下发失败",
    backupOk: "配置备份成功",
    setDecsOk: "描述修改成功",
    downlogCue: "请选择日志级别",
    logLevel: "日志级别",
    selectDownlog: "请选择需要下载的日志",
    logTime: "日志日期",
    logTimeCue: "请选择日志日期",
    logFile: "日志文件",
    downlog: "下载历史日志",
    downCurLog: "下载当前日志",
    log1: "1（系统信息）",
    log3: "3（DSP 命令）",
    log4: "4（DSP 事件）",
    log5: "5（呼叫日志）",
    log6: "6（RTP 事件）",
    log8: "8（注册消息）",
    modLogLevelOk: "日志级别修改成功，设备重启后生效",
    downlogOk: "日志下载成功",
    BackupInfo: "详细备份信息",
    backupId: "备份ID",
    paramID: "参数ID",
    paramName: "参数名称",
    chName: "中文名称",
    enName: "英文名称",
    paramVal: "参数值",
    opTime: "操作时间",
    confCompare: "对比配置",
    lineId: "线路号",
    type: "类型",
    template: "模板",
    backupTem: "参数模板备份",
    backupParam: "参数备份",
    version: "版本号",
    compareRule: "对比对象只能是2个",
    alarmInfo: "告警信息",
    event: "事件",
    createTime: "产生时间",
    callStatus: "呼叫状态",
    accAddr: "请输入设备访问ip地址",
    extInfo: "请输入分机信息",
    record: "录音",
    number: "号码",
    displayName: "显示名称",
    email: "邮箱",
    phoneNumber: "手机号码",
    lineInfo: "请输入用户线信息",
    allRecord: "全程录音",
    callWaiting: "呼叫等待",
    callHold: "呼叫保持",
    callForward: "主叫转接",
    callerID: "来电显示",
    outgoingBar: "禁止呼出",
    reg: "注册",
    username: "用户名",
    pw: "密码",
    trunkInfo: "请输入外线信息",
    revPolDetec: "反极性检测",
    callerIdDetec: "来显检测",
    DIDNumber: "直线号码",
    fxoInput: "请输入中继线信息",
    "ring-back": "回音消除",
    delaySend: "延迟发送接通消息",
    accType: "接入方式",
    bind: "绑定",
    secDailing: "二次拨号",
    did: "直接呼入",
    bindNum: "绑定号码",
    voicePrompt: "语音提示",
    dailToneHint: "拨号音提示",
    loginDev: "登录设备",
    reset: "恢复出厂",
    callOutSta: "外呼状态",
    devAlarm: "设备告警",
    devPw: "设备密码",
    wan: "外网IP地址",
    lan: "局域网IP地址",
    autoUp: "自动检测升级",
    startTime: "启动时间",
    runTime: "运行时间",
    ext: "模拟分机",
    fxs: "用户线",
    trunk: "模拟外线",
    fxo: "中继线",
    ipExt: "IP 分机",
    sipTrunk: "SIP 外线",
    route: "路由表",
    digitmap: "号码位图",
    confTarM: "配置包管理",
    backHistory: "参数备份历史",
    setHistory: "参数下发历史",
    logManage: "日志管理",
    inputurl: "请输入完整URL格式的访问IP",
    upConfirm: "此操作成功后，设备将会开启自动升级，是否继续？",
    enableUp: "此操作成功后，设备将会开启自动升级功能，是否继续？",
    closeUp: "此操作成功后，设备将会关闭自动升级, 是否继续？",
    failOp: "设备自动更新功能关闭失败，请手动到设备配置界面关闭自动更新功能",
    paramSetOk: "参数修改成功",
    paramSetFail: "参数修改失败",
    setRouteOk: "路由配置修改成功",
    setRouteFail: "路由表修改失败",
    backupConfirm: "确认是否备份最新的配置，恢复出厂配置后将不可恢复，是否继续？",
    restartConfirm: "确认重启，重启后设备需要几分钟恢复，是否继续？",
    restartOk: "设备重启操作成功",
    day: "天",
    hour: "小时",
    min: "分钟",
    sec: "秒",
    getConfFail: "设备配置获取失败",
    changePwOk: "密码修改成功",
    changePwFail: "密码修改失败：",
    changePwFail2: "密码修改失败，旧密码输入不正确或两次新密码输入不一致",
    sipSer: "SIP服务器",
    setDigitOk: "号码位图修改成功",
    setDigitFail: "号码位图修改失败",
    more: "高级设置",
    port: "端口",
    ipGain: "往 IP 增益",
    PSTNGain: "往 PSTN 增益",
    OutpulDelay: "拨号延时",
    fxsGain: "往模拟分机增益",
    impedance: "线路阻抗",
    impedance_op1: "复合",
    impedance_op2: "欧姆",
    param225: "最短闪断",
    param226: "最长闪断",
    param220: "振铃频率",
    param439: "来电显示传输模式",
    param494_op1: "有校验位",
    param494_op2: "无校验位",
    param495_op1: "振铃前",
    param495_op2: "振铃后",
    setSipOk: "SIP配置修改成功",
    setSipFail: "SIP配置修改失败",
    inputIpExt: "请输入IP分机信息",
    regOption: "请输入注册选项配置参数",
    regPort: "注册端口",
    minTimeout: "最短注册超时",
    natMinTimeout: "NAT后最短注册超时",
    safeDomain: "安全域",
    illegalReg: "对非法注册处理",
    illegalReg_op1: "回403",
    illegalReg_op2: "不回应",
    ipOption: "向 IP 分机发送 OPTIONS 消息",
    regOptoin: "注册选项",
    line: "线路",
    regIp: "使用IP鉴权时的IP地址",
    regIps:'IP鉴权',
    polderIP:'请输入IP地址，例：192.168.1.1',
    noSend: "不发送",
    natSend: "NAT 下才发送",
    allSend: "全部发送",
    addTrunkOk: "SIP外线添加成功",
    addTrunkFail: "SIP外线添加失败",
    delTrunkOk: "SIP外线删除成功",
    delTrunkFail: "SIP外线删除失败",
    delIpExtOk: "删除IP分机成功",
    delIpExtFail: "删除IP分机失败",
    addIpExtOk: "添加IP分机成功",
    addIpExtFail: "添加IP分机失败，原因可能是：1）设置了相同号码或账号；2）设置有误。",
    open: "开启",
    close: "关闭",
    inputTrunkInfo: "请输入外线信息",
    userDomain: "用户端域名",
    defaultRegIP: "默认注册服务器",
    localPort: "本地端口",
    regTimeOut: "注册超时",
    proxySer: "代理服务",
    transLocalPort: "变换本地端口增量值",
    mulipleReg: "注册多平台",
    param576: "来显信息获取方式",
    param576_op1: "头域中获取",
    param576_op2: "头域中获取",
    accInfo: "接入网信息",
    inputRoute: "请输入路由表信息",
    resetOk: "恢复出厂设置成功,确认现在重启设备？",
    resetFail: "恢复出厂设置失败",
    inputTar: "请选择配置包",
    workMode: '工作模式',
  },
  ISDN: {
    selectLine: "选择线路",
    applyOption: "应用选项",
    getNumType: "收号方式",
    getNumType1: "逐位收号",
    getNumType2: "整体收号",
    dChannel: "D 通道",
    interfacePro: "接口协议",
    channel: "时隙",
    user: "用户侧",
    network: "网络侧",
    singalStandard: "信令标准",
    selectType: "选线方式",
    dChannelManage: "D 通道启用维护消息",
    pointConn: "点对点连接",
    callNumType: "主叫号码类型",
    specification: "规范",
    noSpecification: "非规范",
    CPNpresentation: "主叫号码显示权限",
    CDPNcategory: "被叫号码类型",
    otherBusy: "被叫忙线处理",
    hangUp: "挂断",
    allowChangeLine: "允许对端更换线路",
    secDailing: "二次拨号",
    prompt: "提示方式",
    callNum: "主叫号",
    originCall: "原主叫",
    originOther: "原被叫",
    otherCall: "被叫",
    otherCall1: "原被叫号+二次输入号",
    otherCall2: "二次输入号",
    changeNum: "号码转换",
    "ISDN-D": "ISDN-D 通路",
    isdnNote: "红灯：通道处于锁定状态；黄灯：禁止从 IP 往 ISDN 方向呼叫的通道；绿灯：IP 和 ISDN 间通道畅通",
    isdnSta: "ISDN-D 通路状态",
    work: "工作状态",
    noWork: "非工作状态",
    "ISDN-B": "ISDN-B 通路",
    lock: "锁定",
    unlock: "解锁",
    restart: "重启",
    forward: "顺序",
    backward: "倒序",
    circular: "循环"
  },
  sip: {
    server: "注册服务器",
    domain: "客户端域名",
    regType: "注册方式",
    regOp1: "按线路注册",
    regOp2: "按网关注册",
    regOp3: "每线认证整体注册",
    username: "注册用户名",
    password: "注册密码"
  },
  devSta: {
    onlineN: "在线设备",
    offlineN: "离线设备",
    totalDev: "设备总数",
    newDev: "新设备",
    statistics: "统计",
    statisticsTime: "统计时间",
    onlineRate: "在线率",
    offlineRate: "离线率",
    total: "总计",
    statisticsOk: "统计成功",
    onlineSta: "在线状态",
    firstOnline: "第一次上线时间",
    lastOnline: "最后一次上线时间",
    lastOffline: "最后一次离线时间",
    noReg: "未注册",
    regSuc: "注册成功",
    timeOut: "超时",
    regFail: "注册失败",
    reging: "注册中",
    domainFail: "域名解析失败",
    voltageSta: "电压",
    voltage: "电压低",
    conn: "已接线",
    disconn: "未接线",
    connSta: "接线状态",
    lastcall: {
      "0": "无呼叫",
      "1": "呼入振铃",
      "9": "呼出回铃",
      "2": "呼入正常",
      "10": "呼出正常",
      "3": "呼入失败",
      "11": "呼出失败",
      "4": "呼入超时",
      "12": "呼出超时"
    },
    lastcallcode: {
      "1": "拨号超时",
      "2": "ACK 超时",
      "301": "永久离开",
      "302": "暂时离开",
      "400": "无效请求",
      "403": "禁止",
      "404": "空号",
      "405": "方法不允许",
      "408": "请求超时",
      "415": "媒体类型不支持",
      "423": "注册周期过短",
      "480": "暂不可访问",
      "481": "呼叫支路/事务不存在",
      "486": "被叫忙",
      "488": "被叫不接受请求",
      "500": "服务器内部错误",
      "502": "网关错误",
      "503": "服务不可用",
      "504": "呼叫超时",
      "603": "呼叫拒绝"
    },
    online: "在线",
    offline: "离线"
  },
  devUp: {
    test: "测试",
    statistics: "统计",
    upgrade: "升级",
    autoUp: "自动升级",
    upLog: "升级记录",
    autoUpLog: "自动升级记录",
    kernelV: "kernel 版本",
    appV: "app 版本",
    upTaskInfo: "升级任务详情",
    taskName: "任务名称",
    createTime: "创建时间",
    doTime: "执行时间",
    result: "执行结果",
    unknown: "未知",
    failReason: "失败原因",
    firmwareV: "升级包版本号",
    upDev: "升级设备",
    sucDev: "成功设备",
    failDev: "失败设备",
    modTask: "修改升级任务",
    cancelTask: "取消任务",
    description: "描述",
    baseV: "基础版本要求",
    package: "升级包",
    init: "初装",
    dev: "设备",
    inputMac: "请输入设备MAC,以逗号分隔",
    addTask: "创建升级任务",
    inputDesc: "请输入描述信息",
    inputTime: "请选择任务时间",
    selectPackage: "请选择升级包",
    addUpOk: "创建升级任务成功",
    addValidFail: "任务创建失败，任务执行时间,任务描述，升级包为必填项",
    modUpOk: "升级任务修改成功",
    modValidFail: "任务修改失败，任务执行时间,任务描述，升级包为必填项",
    upInfo: "升级版本信息",
    inputAutoUp: "请输入自动升级信息",
    selectTime: "请选择时间",
    suc: "升级成功",
    fail: "升级失败",
    addAutoUpOk: "添加自动升级成功",
    modAutoUpOk: "修改自动升级成功",
    delAutoUpOk: "删除自动升级成功",
    inputTask: "请选择任务",
    inputHistory: "请选择记录"
  },
  task: {
    section: "分块",
    menu: "菜单",
    reboot: "重启设备",
    tarBackup: "备份配置",
    logType: "日志类型",
    curLogBackup: "下载日志",
    logBackup: "下载历史日志",
    getParamTem: "按模板备份参数",
    setParamTem: "按模板下发参数",
    setTask: "下发克隆配置",
    getParam: "参数备份",
    setParam: "下发参数",
    importDev: "设备导入",
    getParam: "参数备份",
    backupConf: "批量备份配置包",
    batchBackup: "批量备份配置",
    batchLogDown: "批量日志下载",
    modTaskTitle: "请输入任务信息",
    start: "启动",
    restart: "重启",
    stop: "停止",
    cancel: "终止",
    loop: "循环任务",
    week: "周",
    day: "天",
    series: "系列",
    doTime: "执行时间",
    selectTime: "请选择时间",
    description: "描述",
    inputDecs: "请输入描述信息",
    taskInfo: "任务详情",
    taskType: "任务类型",
    taskId: "任务 ID",
    taskName: "任务名称",
    monday: "周一",
    tuseday: "周二",
    wednesday: "周三",
    thursday: "周四",
    friday: "周五",
    saturday: "周六",
    sunday: "周日",
    monday_d: "周一",
    tuseday_d: "周二",
    wednesday_d: "周三",
    thursday_d: "周四",
    friday_d: "周五",
    saturday_d: "周六",
    sunday_d: "周日",
    everyDay: "每天",
    isRestart: "是否重启",
    operator: "操作人",
    taskStop: "任务停止",
    taskRun: "任务运行中",
    taskCancel: "任务已取消",
    progress: "进度",
    selectTaskTime: "请选择任务时间",
    all: "全部任务",
    onetime: "单次任务",
    period: "周期任务",
    modTaskFail: "任务修改失败，执行时间，描述为必填项",
    model: "模板",
    selectModel: "请选择模板",
    dev: "设备",
    dev_note: "请从设备表中选取设备,或者手动输入设备MAC地址，以逗号分隔，如A9039E3412,A90E003455",
    inputDev: "请选择设备",
    restartConfirm: "任务完成后设备将立即重启，确认是否继续",
    addTaskOk: "任务创建成功",
    addTaskFail: "任务创建失败，任务执行时间，模板，描述，设备为必填项",
    addTaskFail2: "任务创建失败，任务执行时间，描述，设备为必填项",
    addTaskFail3: "任务创建失败，任务执行时间，描述，设备，参数为必填项",
    addTaskFail4: "任务创建失败，任务执行时间，日志日期，描述，设备为必填项",
    result: "执行结果",
    status: "状态",
    reason: "失败原因",
    needRestart: "需要重启",
    noNeedRestart: "不需要重启",
    lastTime: "最后一次执行时间",
    sucDev: "成功设备",
    failDev: "失败设备",
    failMac: "失败设备MAC",
    failReason: "失败原因",
    paramID: "参数ID",
    paramVal: "参数值",
    confParam: "配置参数",
    downTime: "下载时间",
    specParm: "个性化参数",
    inputSpecParam: "请输入个性化参数，格式如：&51=test&99=on",
    inputSpecParamId: "请输入个性化参数id以逗号分割，如：51,57",
    taskBefore: "历史任务",
    dateUntil: "查询历史任务至日期",
    currentTask: "当前任务",
    query: "查询",
    to: " 至 ",
    confModel: "配置克隆模板",
    retry: "重新执行",
    retryCue: "您将要对失败的设备重新执行任务"
  },
  alarm: {
    setDeployMsg1: '是否删除{time}以后的呼叫记录？',
    setDeployMsg2: '是否删除{time}以前的呼叫记录？',
    setDeployMsg3: '是否删除从{sTime}至{eTime}的呼叫记录？',
    alog: '日志',
    device: "告警设备",
    all: "所有设备",
    groupSet: "按组设置",
    proTypeSet: "按型号设置",
    userDefined: "自定义选择",
    serve:"平台地址",
    devGroup: "设备组",
    proType: "型号",
    setAlarm: "告警设备设置成功",
    inputAlarm: "请输入告警信息",
    event: "事件",
    name: "名称",
    level: "级别",
    red: "红色告警",
    orange: "橙色告警",
    normal: "一般告警",
    unknow: "未知告警",
    inputName: "请输入告警名称",
    inputEvent: "请填写告警事件,如Event=29",
    selectLevel: "请选择告警级别",
    addOk: "添加告警事件成功",
    modOk: "修改告警事件成功",
    delOk: "删除告警事件成功",
    history: "警报记录",
    history_event: "事件记录",
    alarmName: "警报名称",
    createTime: "产生时间",
    email: "邮件通知",
    noSend: "未发送",
    weChat: "微信通知",
    weChat_num: "微信号",
    phone: "电话通知",
    phoneNum: "号码",
    confirm: "确认",
    confirmed: "已确认",
    selectWechat: "请选择微信号码",
    selectEmail: "请选择邮箱",
    selectPhone: "请选择电话",
    selectDelWechat: "请选择需要删除的微信号码",
    selectDelEmail: "请选择需要删除的邮箱",
    selectDelPhone: "请选择需要删除的号码",
    inputEmail: "请输入邮箱地址",
    emailAddr: "邮箱",
    inputPhone: "请输入电话号码",
    dev: "告警设备",
    rule: "告警规则",
    period: "阈值",
    periodText: "{period}分钟内发生>={times}次，触发警报",
    periodText1: "分钟内发生 >= ",
    periodText2: "次，触发警报",
    delay: "延迟",
    delayText: "秒告警",
    qrCode: "扫描二维码",
    action: "动作",
    downlog: "下载日志",
    restartapp: "重启app",
    ruleNormal: "正常",
    ruleAlarm: "警报待确认",
    inform: "通知",
    informNote: "通知（当你定义的警报触发警报状态时，发送通知到）",
    creator: "创建者",
    log: "记录",
    selectEv: "请选择事件",
    inputRuleName: "请输入规则名称",
    inputRuleDesc: "请输入规则描述",
    addEmailOk: "添加邮箱成功",
    delEmailOk: "删除邮箱成功",
    delWechatOk: "删除微信成功",
    addPhoneOk: "添加电话成功",
    delPhoneOk: "删除电话成功",
    addRuleOk: "添加告警规则成功",
    modRuleOk: "修改告警规则成功",
    delRuleOk: "删除告警规则成功",
    monitorInfo: "监控详情",
    enable: "开关",
    devView: "设备",
    batch: "批量",
    searchMac: "请输入设备MAC地址进行搜索",
    enabled: "监控告警开关已打开",
    closed: "监控告警开关已关闭",
    rebootCue: ",设备重启后生效",
    batchSetEnable: "批量设置监控开关成功",
    actionNote: "操作（当你定义的警报触发警报状态时，要执行的操作）",
    addAlarmT: "创建警报",
    modAlarmT: "修改警报",
    selectedDev: "已选择的设备",
    viewSelected: "查看已选设备",
    deviceInfo: "设备信息",
    emptyEmails: "邮件列表为空，请点击通知列表进行添加",
    emptyWechats: "微信列表为空，请点击通知列表进行添加",
    emptyPhones: "电话列表为空，请点击通知列表进行添加",
    notifications: "通知列表",
    statusDesc: "警报状态对48个小时之内的告警记录有效",
    confirmAll: "确定要确认所有的警报记录？",
    confirmDelEmails: "删除成功后，已创建的警报也不再通知该邮箱",
    confirmDelPhones: "删除成功后，已创建的警报也不再通知该电话",
    confirmDelWechats: "删除成功后，已创建的警报也不再通知该微信",
    monitorG: "监控组",
    monitorTime: "监控时长（天）",
    queryAll: "查看该设备所有事件",
    delDevice: "确定要将该设备从该监控组删除吗？",
    delGroupConfrim: "确定要将该设备组从该监控组删除吗？",
    monitorGroupTitle: "请输入监控组信息",
    syncTime: "数据同步时间",
    weiweiStat: "喂喂统计",
    statLog: "统计日志",
    recStat: "全录统计",
    sysStat: "系统统计",
    rec: "全录",
    linelockTime: "检测周期",
    linelock: "O口咬线",
    recLog: "全录日志",
    recToCloudLog: "全录上报日志",
    avg: "呼叫接通通话平均时长",
    delete: "删除时间",
    ext: "注册分机号",
    firstregtime: "当日首次注册时间",
    in: "呼入接通次数",
    inmiss: "呼入未接通次数",
    lastregtime: "当日最后注册时间",
    ou: "呼出接通次数",
    oumiss: "呼出未接通次数",
    pushfail: "推送失败次数",
    pushok: "推送成功次数",
    sys: "",
    total: "呼出接通通话总时长",
    clickdial: "点击拨号",
    note: "便签",
    getrecord: "听录音",
    contactexport: "通讯录导入导出",
    mccs: "侬好服务端",
    sip_send: "SIP发送",
    sip_recv: "SIP接收",
    callStat: "呼叫统计",
    rtpStat: "语音统计",
    appStat: "App统计",
    timeStamp: "时间戳",
    fxo_disc: "O口断开",
    fxo_volt: "O口电压告警",
    eth_down: "网络down",
    web_atmp: "web误登入",
    ssh_atmp: "ssh误登入",
    dns_err: "DNS出错",
    queue: "内部队列满",
    failover: "呼叫出错转O口",
    rec_cnt: "录音计数",
    rec_err: "录音出错",
    rec_chg: "录音由远程转本地",
    ww_cnt: "喂喂推送计数",
    ww_reg: "喂喂推送及时收到注册",
    ww_to: "喂喂推送呼叫超时",
    invite: "INVITE 消息",
    inv_dup: "INVITE 重发",
    cancel: "CANCEL 消息",
    reg: "注册消息",
    R200: "注册200 OK",
    R401: "注册401",
    R403: "注册403",
    c_200: "呼叫应答",
    c_403: "呼叫拒绝",
    c_408: "呼叫无应答",
    c_412: "呼叫不在线",
    c_480: "超时",
    c_486: "忙线",
    c_5XX: "其他错误",
    inc: "呼入",
    i_ans: "呼入接通",
    i_comp: "呼入完成",
    i_fail: "呼入未完成",
    i_act: "呼入当前",
    i_dur: "呼入计时",
    out: "呼出",
    o_ans: "呼出接通",
    o_comp: "呼出完成",
    o_fail: "呼出出错",
    o_act: "呼出当前",
    o_dur: "呼出计时",
    ps: "包发送",
    os: "byte 发送",
    pr: "包接收",
    or: "byte接收",
    pl: "包丢失",
    sl: "包发送丢失",
    intl: "包内部丢失",
    invlid: "非法RTP",
    dup: "序列号重复",
    nortp: "未收到RTP计时",
    inputMonitorName: "请填写监控组名称",
    warn44: "警告44",
    warn45: "警告45",
    warn46: "警告46",
    warn47: "警告47",
    warn39: "警告39",
    recv_count: "收到录音的个数",
    finish_count: "结束录音的个数",
    rec_len: "总通话时长",
    record_count: "成功合成录音的个数",
    rec_loss: "录音包丢失的个数",
    max_conn: "该时段录音并发数达到的上限",
    max_convqueue: "该时段录音转换合成队列达到的上限",
    recv_error: "UDP接收遇到的错误",
    send_error: "UDP发送遇到的错误",
    rtpdata_error: "录音包体格式不符合",
    conv_error: "录音合成转换错误",
    sendEmail_error: "留言发送邮箱错误",
    movefile_error: "录音搬移保存错误",
    uploadLog: "上传全录日志",
    uploadConfirm: "您将要上传全录日志： ",
    cloud: "云平台",
    logTime: "记录时间",
    Stating: "开始统计信息，请稍后查询",
    modLevelOk: "修改全录参数成功",
    recParam: "全录参数",
    queryOk: "查询成功",
    filter: "过滤",
    filterOk: "过滤成功",
    is_analized: "是否已分析",
    originData: "原始数据",
    statData: "数据图表",
    recOnlineRate: "全录在线率",
    recUseRate: "全录使用率",
    groupRecOnlineRate: "监控组全录在线率",
    groupUseRate: "监控组全录使用率",
    recParamCue: "请选择全录参数",
    turnonLog: "开启日志搬移",
    turnonScource: "开启资源监控",
    turnonFsp: "开启fsp运行",
    preserveRecord: "本地保存断网录音",
    logStorageCue: "您确定要更改日志搬移设置？",
    fspCue: "您确定要更改fsp设置？",
    recordCue: "您确定要更改本地保存断网录音设置？",
    setOk: "设置成功",
    isStating: "统计中",
    periodic: "设备信息统计周期（秒）",
    rec_stat: "全录统计周期（秒）",
    rec_hb: "全录心跳周期（秒）",
    turnoffSourceCue: "您确定要关闭资源监控设置？",
    samplingTime: "采样时间（秒）",
    runTime: "运行天数（天）",
    CPUUse: "CPU使用情况",
    recordWay: "录音方式",
    record_remote: "远程录音",
    record_waizhi: "外部USB设备",
    record_neizhi: "内置存储",
    record_sever: "录音服务器",
    inputParam: "请输入参数值",
    ParamRang: "参数值必须为0或者大于等于{minParam}",
    statRang: "参数值必须大于等于0",
    statFail: "统计失败",
    onlineTime: "在线时长（小时）",
    recoedNum: "录音个数",
    maxcOncurrent: "最大并发数",
    averageTime: "平均通话时长（分钟）",
    startUploadLog: "开始上传日志",
    averageOnlineTime: "平均在线时长（小时）",
    callStatAndNeizhi: "呼叫统计和录音统计",
    downDate: "下载日期",
    addSingleDevCue: "您将要添加该设备至：",
    inputAppName: "请输入全录名称",
    inputRec: "请选择全录",
    inputRecLabel: "应用",
    modAppCue: "修改全录",
    recTypeSummary: "内置存储共 {innerCount} 台，远程录音共 {remoteCount} 台，未知存储方式共 {unknownCount} 台",
    noDevice: "暂无设备",
    isUploadingLog: "正在上传日志",
    noexsitingInUms: "该设备不在网管，请至设备列表进行添加",
    weiweiDetail: "喂喂详情",
    innerRec: "内置录音",
    neehaoStat: "侬好统计",
    weiweiMonitor: "数据上报",
    turnOnWeiweiMonitor: "您将要开启该设备的数据上报功能",
    turnOffWeiweiMonitor: "您将要关闭该设备的数据上报功能",
    fileUpload: "语音通知",
    description: "描述",
    voice: "语音",
    selectDelVoice: "请选择需要删除的语音",
    delVoiceOk: "删除语音文件成功",
    selectVoice: "请选择语音",
    emptyVoice: "语音列表为空，请点击通知列表进行添加",
    playVoice: "播放录音",
    shout: "呼叫监控",
    hostMachine: "主机",
    slaveapplication: "备机",
    hostInput: "请从列表中选择一个主机名",
    slaveInput: "请选择多个备机",
    addHostMachine: "添加设备",
    startTime: "选择开始时间",
    endTime: "选择结束时间",
    until: "至",
    deleteAll: "是否删除所有呼叫监控记录？",
    if: "是否",
    complateDate: "选择的时间间隔需为三个月之内",

  },
  event: {
    eventArray0: "当前无告警",
    eventArray1: "设备重启",
    eventArray2: "DS1 down",
    eventArray3: "DS1 up",
    eventArray4: "ISDN down",
    eventArray5: "ISDN up",
    eventArray6: "ENDPOINT CHANGE",
    eventArray7: "软件退出",
    eventArray8: "EMS hold",
    eventArray9: "EMS unhold",
    eventArray10: "IP 中继注册失败",
    eventArray10_MX_1: "用户线注册失败",
    eventArray10_MX_2: "中继线注册失败",
    eventArray11: "IP 中继注册成功",
    eventArray11_MX_1: "用户线注册成功",
    eventArray11_MX_2: "中继线注册成功",
    eventArray12: "软件重启",
    eventArray13: "WAN 口重新连接",
    eventArray14: "修改密码",
    eventArray15: "登录成功",
    eventArray16: "登录失败告警",
    eventArray17: "Error registration",
    eventArray18: "DNS error",
    eventArray19: "IP地址变更",
    eventArray20: "配置变更",
    eventArray21: "WAN 口连接已断开",
    eventArray22: "FXO 口未接线",
    eventArray23: "FXO 口连线",
    eventArray24: "内部消息队列超载",
    eventArray25: "INVITE 超时",
    eventArray26: "SSH 登入",
    eventArray27: "IP 攻击",
    eventArray28: "恢复出厂配置",
    eventArray29_1: "模拟外线 ",
    eventArray29_2: " 异常（电压过低）",
    eventArray30: "分机组不可达",
    eventArray31: "主备切换",
    eventArray32: "RTP端口数小于并发数",
    eventArray33: "为空",
    eventArray33_1: "对应的DID号码",
    eventArray34: "本设备不存在",
    eventArray35: "IP分机离线",
    eventArray36: "IP分机上线",
    eventArray37: "IP分机注销",
    eventArray38: "IP分机有重复注册",
    eventArray39: "喂喂离线",
    eventArray40: "喂喂上线",
    eventArray41: "喂喂注销",
    eventArray42: "同时录音超出范围",
    eventArray43: "远程录音失败转本地",
    eventArray44: "服务器录音超出范围",
    eventArray45: "服务器录音超出恢复",
    eventArray46: "服务器录音繁忙",
    eventArray47: "服务器录音繁忙恢复",
    eventArray48: "RTP 告警",
    eventArray48_1: "RTP 告警（单通）",
    eventArray48_2: "RTP 告警（丢包超阈值）",
    eventArray_DID: "外线号码",
    loginArray0: "操作员登录",
    loginArray1: "管理员登录",
    changePw0: "修改操作员密码",
    changePw1: "修改管理员密码",
    changePw2: "修改 SSH root 用户密码",
    changePw3: "修改 SSH operator 用户密码",
    loginAttemptArray0: "未知用户尝试登录",
    loginAttemptArray1: "远程登录请求被禁止",
    loginAttemptArray2: "Web 登录失败",
    loginAttemptArray3: "IP 登录失败超限",
    loginAttemptArray4: "登录密码为空",
    event_part1: "收到",
    event_part2: "个异常注册请求",
    event_dns: "DNS 解析失败",
    callTimeout1: "呼叫 ",
    callTimeout2: " 超时",
    dosAttack: "DoS 攻击",
    sshfail: "SSH 登录失败",
    wrong: "错误 "
  },
  callStatus: {
    lineId: '线路id',
    number: '号码',
    calling: "通话中",
    free: "空闲",
    settingUp: "呼叫建立中",
    other: "其它",
    lineName: "线路名称",
    regSta: "注册状态",
    lineSta: "线路状态",
    curCall: "当前呼叫",
    otherNum: "对方号码",
    callTime: "通话时长",
    lastCall: "末次呼叫",
    errorcode: {
      "1": "拨号超时",
      "2": "ACK 超时",
      "301": "永久离开",
      "302": "暂时离开",
      "400": "无效请求",
      "403": "禁止",
      "404": "空号",
      "405": "方法不允许",
      "408": "请求超时",
      "415": "媒体类型不支持",
      "423": "注册周期过短",
      "480": "暂不可访问",
      "481": "呼叫支路/事务不存在",
      "486": "被叫忙",
      "488": "被叫不接受请求",
      "500": "服务器内部错误",
      "502": "网关错误",
      "503": "服务不可用",
      "504": "呼叫超时",
      "603": "呼叫拒绝"
    },
    sta: {
      regStatus0: "未注册",
      regStatus1: "注册成功",
      regStatus2: "注册失败",
      regStatus3: "注册无应答",
      regStatus4: "超时",
      lineStatus0: "空闲",
      lineStatus1: "摘机",
      lineStatus2: "振铃",
      lineStatus3: "维护",
      lineStatus4: "未接线",
      lineStatus5: "并线摘机",
      callStatus0: "空闲",
      callStatus1: "振铃前检测来显",
      callStatus2: "向外拨号中 ",
      callStatus3: "振铃",
      callStatus4: "用户拨号中 ",
      callStatus5: "发起呼叫 ",
      callStatus6: "回铃",
      callStatus8: "通话",
      callStatus9: "本端挂机",
      callStatus10: "超时",
      callStatus11: "对方挂机",
      callStatus12: "未知",
      c: "主叫",
      d: "被叫",
      lastcall_1: "无呼叫",
      lastcall_2: "呼入振铃",
      lastcall_3: "呼出回铃",
      lastcall_4: "呼入正常",
      lastcall_5: "呼出正常",
      lastcall_6: "呼入失败",
      lastcall_7: "呼出失败",
      lastcall_8: "呼入超时",
      lastcall_9: "呼出超时"
    },
    getStaFail: "状态数据获取失败"
  },
  ISDNSTA: {
    ID: "序号",
    callSta: "呼叫状态",
    CallDirection: "呼叫方向",
    callNumber: "主叫号码",
    otherNumber: "被叫号码",
    param1: "操作",
    param2: "未启用",
    param3: "空闲",
    param4: "呼叫起始",
    param5: "呼出进程",
    param6: "呼叫递交",
    param7: "呼入起始",
    param8: "呼入进程",
    param9: "呼叫接收",
    param10: "连接请求",
    param11: "通话中",
    param12: "拆线指示",
    param13: "拆线请求",
    param14: "释放请求",
    param15: "重叠接收"
  },
  tdm: {
    ds1: "DS1类型",
    pcm: "PCM 编码",
    sync: "同步方式",
    frame: "帧格式",
    line: "线路码",
    cable: "线缆距离",
    cableImpedance: "线缆阻抗",
    local: "本地",
    m: "米",
    long: "长线",
    short: "短线",
    confOk: "设备配置成功",
    confFail: "设备配置失败"
  },
  telnet_ssh: {
    stopTimeTitle: "请选择有效期",
    stopTime: "有效期",
    access: "访问身份",
    confirmPw: "确认密码",
    createSSH: "创建SSH代理访问",
    cancelSSH: "取消SSH代理访问",
    createTelnet: "创建Telnet代理访问",
    cancelTelnet: "取消Telnet代理访问",
    proxyIP_ssh: "SSH 代理访问地址",
    proxyDeadLine_ssh: "SSH 代理有效期",
    proxyIP_tel: "Telnet 代理访问地址",
    proxyDeadLine_tel: "Telnet 代理有效期",
    selectDeadLine: "请选择有效期",
    createOk: "代理服务创建成功",
    delOk: "代理服务删除成功",
    confirm: "当前有其它客户端登录设备，是否强制登录并继续修改配置？",
    confFail: "修改配置失败",
    confOk: "重启设备后配置生效",
    telnetPort: "Telnet 端口",
    sshPort: "SSH 端口",
    changeVcode: "换一张"
  },
  user: {
    select: "请选择",
    account: "账号",
    pw: "密码",
    confirmPw: "确认密码",
    userName: "用户名",
    phone: "手机号码",
    contacts: "联系人",
    token:'Token',
    token1:'Token：',
    generate:'生成token',
    lock: "锁定",
    groupReq: "设备组为必填项",
    pwReq: "密码为必填项",
    inputError: "您输入的内容不符合要求",
    unallow: "此操作将禁止此用户访问系统，是否继续？",
    allow: "此操作将允许此用户访问系统，是否继续？",
    addUser: "请输入用户信息",
    inputAcc: "请输入账号",
    inputAcc1: "账号必须是 5 到 16 位字母、数字、下划线且必须以字母开头",
    accRule: "长度为 3 到 15 个字符",
    inputUsername: "请输入用户名",
    addUserOk: "添加用户成功",
    modUserOk: "修改用户成功",
    delUserOk: "删除用户成功",
    safe: "安全设置",
    user_level: "用户类型",
    domainAdmin: "管理员",
    userAdmin: "用户",
    sysadmin: "超级管理员",
    selectDomain: "请选择域",
    opFail: "账号名已被使用，请重新输入",
    "groupTip": '设备组选择不能跨域',
    tokenOk:'生成token成功',
    tokenverok:"修改验证模式成功",
    tokentip:"token绑定"
  },
  role: {
    select: "请选择",
    label: "角色",
    selectRole: "请选择角色",
    addRoleS: "添加角色成功",
    modRoleS: "修改角色成功",
    delRoleS: "删除角色成功",
    addRole: "请输入角色信息",
    selectUserLevel: "请选择用户类型",
    name: "别名",
    pri: "权限",
    roleID: "名称",
    roleAlarm: "角色名称已被使用，请重新输入",
    roleRequire: "角色名称不能为空"
  },
  cloudID: {
    inputId: "请输入你的云账号信息",
    title: "注意：请把网管的IP地址添加到你的云账号安全组许可访问地址列表里，否则可能造成“设备不可达”。",
    account: "云账号",
    domain: "域",
    token: "令牌",
    nickName: "别名",
    update: "同步时间",
    tokenUpdate: "设备同步",
    inputCloud: "请输入云账号",
    number: "必须为数字值",
    inputToken: "请输入令牌",
    devInpro: "，已扫描设备{count}台",
    unsynchronized: "未同步",
    regRefresh: "定时同步（每天）",
    manualRef: "手动同步"
  },
  dataBackup: {
    uploadCue: "请上传历史备份信息",
    backupTar: "备份包",
    backup: "备份",
    recover: "恢复",
    content: "存储内容",
    spaceUse: "占用空间",
    clear: "清除",
    param: "设备参数",
    log: "操作日志",
    task: "数据清理",
    devUp: "设备升级",
    devSta: "设备状态",
    devLog: "设备日志",
    devBackup: "设备备份配置",
    firmware: "升级包",
    recoverOk: "恢复配置成功",
    confirm: "此操作将永久清除，是否继续？",
    // clearOk: "数据清理成功",
    callstate: '呼叫监控记录',
    clearOk: "清理数据大概需要{cleanTime}分钟",
    date: "日期",
    week: "一周前",
    oneM: "一个月前",
    threeM: "三个月前",
    sixM: "六个月前",
    year: "一年前",
    selectDate: "请选择日期",
    confirmThreeM: "确认清除三个月前的数据",
    cleanCue: "清除历史记录信息",
    dateBefore: "删除日期",
    dateAfter: "以前的历史数据",
    metricHistory: "事件历史记录",
    alarmHistory: "告警记录",
    confirmBackUp: "确定要备份数据吗？",
    storageAll: "总容量",
    diskStorage: "磁盘容量（共{storageAll}GB",
    disk_free: "可用容量",
    disk_used: "已用容量",
    clean_db_config: "自动清理",
    clean_db_config_info: "自动清理数据库配置",
    clean_db_config_label2: '设备日志保存时长',
    clean_db_config_label3: '事件历史记录保存时长',
    clean_db_config_label4: '自动清理时间',
    clean_db_config_ok: '配置成功',
    clean_db_tip_info: '0 表示关闭此功能',
    clean_valid_info: '请输入数字',
    backupconfig:'自动备份',
    backConfigInfo:'自动备份配置',
    perMonth:'每隔',
    geri:'当月',


  },
  domain: {
    addDomain: "请输入域名称信息",
    domainName: "域",
    id: "ID",
    inputDomain: "请输入域的名称",
    addDomainS: "添加域成功",
    modDomainS: "修改域成功",
    delDomainS: "删除域成功"
  },
  firmware: {
    baseVersion: "请输入基础版本信息",
    firmwareTitle: "请输入升级包信息",
    componentTitle: "请输入组件信息",
    baseApp: "基础 App 版本",
    baseKernel: "基础 kernel 版本",
    baseOther: "其它基础版本",
    baseOtherNote: "输入格式如：autoupd:3.0.145;boa:2.0.48",
    kernelVersion: "kernel 版本",
     kernelVersionMaxLength: "kernel 版本最大长度为 {length} 个字符",
    test: "测试版本",
    firmware: "升级包",
    proType: "产品型号",
    version: "版本",
    lang: "语言",
    ch: "中文",
    en: "英文",
    multiLang: "多语言",
    release: "Release说明",
    component: "组件",
    release2: "Release 说明：",
    baseApp2: "基础 App 版本：",
    baseKernel2: "基础 kernel 版本：",
    baseOther2: "其它基础版本：",
    fileSize: "文件大小",
    uploadTime: "上传时间",
    baseVersionRule: "基础版本要求",
    inputRelease: "请输入release相关信息",
    inputApp: "请输入app版本号",
    selectFirmware: "请选择升级包",
    delOk: "删除成功",
    modOk: "修改成功",
    addOk: "添加成功",
    uploadRule: "上传文件名必须是cloud_basic开头",
    cloudPackage: "云平台升级包",
    cloudVersion: "版本信息",
    force_upgrade: "强制升级",
    rlsTitle: "名称",
    series: "系列",
    aws: "存放至aws",
    yes: "是",
    no: "否",
    inputRlsT: "请输入升级包名称",
    inputVer: "请输入升级包版本信息",
    selectSeries: "请选择升级包所属系列",
    selectProduct: "请选择升级包所属型号",
    isTestVer: "是否为测试版本",
    type: "类型",
    jkType: '监控类型',
    isForceUpgrade: "是否为强制升级",
    ipphonePlaceholder: '请输入和升级包一致的版本号信息，否则会导致升级失败'
  },
  sysInfo: {
    import: "导入 License",
    license: "请导入License文件",
    info: "License 信息",
    reqKey: "证书申请码：",
    deviceLimit: "可管理设备数量：",
    stopTime: "有效期至：",
    server: "服务器信息",
    domain: "域名：",
    localIP: "本地 IP 地址：",
    version: "系统版本",
    update: "检查更新",
    curVersion: "当前版本：",
    newVersion: "新版本：",
    newVersionRel: "版本信息： ",
    upgrade: "升级",
    getVerF: "版本信息获取失败",
    upLicenseOk: "License上传成功，系统重启后生效",
    modSerInfoOk: "服务器信息修改成功！如果修改了端口，必须重启UMS服务器后才能用修改后的端口登录。确认现在重启？",
    restartOk: "重启成功，请重新登录",
    restartFail: "重启失败",
    restarting: "正在重启，请稍后",
    serverPort: "端口： ",
    confirmRestart: "确认要重启网管吗？",
    pushInfo: '推送配置', //新增
    pushAlarm: '告警推送：', //新增
    pushDevice: '设备状态推送：', //新增
    pushUrl: '推送地址：', //新增
    urlInfoTip: '格式：协议://域名:端口/自定义目录，协议为http或者https，域名也可设置为IP地址，自定义目录可设置为多层目录，如:/push/test', //新增
    success: '提交成功', //新增
    pushOn: '开启',
    pushOff: '关闭',
    MsgTip: '请填写推送地址',
    noConfig: '未配置',
    pushAlarmType: '告警推送类型：',
    alarmCycleTitle: '统计周期配置',
    alarmCycle: '告警统计周期：',
    callCycle: '呼叫统计周期：',
    recently: '最近',
    hour: '小时',
    day: '天',
    month: '月',
    min:'分钟',
    initLang: '登录的默认语言',
    langConfig: "语言配置：",
    pri:'已开启的通知：',
    email:'邮件',
    weixin:'微信',
    phone:'电话',
    logUms:'ums：',
    logUmsdevice:'umsdevice：',
    logUmswatch:'umswatch：',
    logType:'日志类型：',
    logretry:'登录重试锁定', //身份鉴别
    maxFailCount:'最大失败登录次数：',
    lockDuration:'锁定时长：',
    lockRange:'（范围：0~59）',
    webdisable: '禁用',

  },
  log: {
    selectLogType: "请选择日志类型",
    originIp: "源IP",
    login: "登入",
    loginout: "登出",
    token: "令牌",
    group: "分组",
    device: "设备",
    firmware: "升级包",
    domain: "域",
    user: "用户",
    privilege: "权限"
  },
  template: {
    param: "参数模板",
    name: "模板名称",
    file: "配置克隆",
    desc: "备注",
    fileName: "文件名称",
    inputParamVal: "请输入参数值",
    mod: "修改模板",
    info: "模板详情",
    paramType: "参数类型",
    paramOption: "参数选项",
    createTime: "创建时间",
    createOp: "创建人",
    inputName: "请输入模板名称",
    opFail: "操作失败，模板重复添加",
    validFail: "添加的参数信息不符合要求，请重新添加",
    addTemFail: "模板名称已被使用，请重新输入",
    configFile: "配置文件",
    selectDev: "请在下列设备列表中选中需要配置克隆的设备",
    getFile: "请获取文件"

  },
  param: {
    uploadExcel: "请上传参数表",
    inputContent: "请输入参数相关信息",
    inputType: "显示控件",
    valList: "值列表",
    default: "默认值",
    inputParamID: "请输入参数ID",
    inputName: "请输入参数名称",
    inputChName: "请输入参数中文名称",
    inputEnName: "请输入参数英文名称",
    select: "下拉框",
    mult_select: "多选框",
    input: "输入框",
    radio: "单选框",
    readOnly: "只读参数",
    repeat: "操作失败，参数重复添加",
    info: "详细信息",
    section: '分块',
  },
  devInsp: {
    devInspection: "设备诊断",
    serviceInfo: "服务信息",
    createHttps: "创建Https服务",
    createTelent: "创建Telnet服务",
    createSSH: "创建SSH服务",
    cmd: "命令",
    p2pTest: "P2P测试",
    p2pResult: "P2P客户端",
    downLog: "下载设备日志",
    run: "执行",
    param: "参数",
    createS: "服务创建成功",
    deleteS: "服务删除成功",
    logList: "日志列表",
    refreshLog: "重新获取",
    reloadOk: "获取成功",
    start: "开始抓包",
    stop: "结束抓包",
    statusCheck: "设备在线状态检查",
    goto: "前往",
    downusbLog: "下载USB日志",
    viewLog: "查看日志目录",
    viewUsbLog: "查看U盘目录",
    viewTmp: "查看tmp",
    ps: "查看进程",
    netstat: "查看网络"
  },
  directSell: {
    withOneWeek: "最近一周",
    withOneMonth: "最近一个月",
    newDevice: "新上线设备",
    newDeviceList: "新上线设备详情列表",
    abormalDevice: "异常设备",
    abormalDeviceList: "异常设备详情列表",
    otherOperations: "其他操作",
    firmwareVersion: "固件版本",
    fxoLine: "FXO线路",
    fxoLineName: "FXO口线路名称",
    lineID: "线路ID",
    userID: "用户ID",
    connectIP: "连接IP",
    diagName: "诊断名称",
    diagResult: "执行状态",
    diagTime: "创建时间",
    diagParam: "诊断参数",
    diagStep: "诊断步骤及状态",
    createDiag: "创建诊断",
    startDiag: "开始诊断",
    diagInfo: "诊断信息",
    diagType: "诊断类型",
    FXO: "O口诊断（CID、回音、增益、忙音）",
    FXO_CID: "O口诊断（CID、增益、忙音）",
    FXO_ECHO: "O口诊断（三方回音测试）",
    prepare: "测试准备",
    huiYinTest: "回音测试",
    mangYinTest: "CID增益，忙音检测",
    finish: "诊断结束",
    phone_num: "电话号码",
    FXO_cue: "该诊断将会自动重启APP",
    cancelDiag: "已取消诊断",
    diagFail: "诊断失败",
    requireName: "请选择诊断类型",
    requireLine: "请选择诊断线路",
    requireName: "请填写号码"
  },
  api_app: {
    api: "API应用",
    whiteList: "访问设备白名单",
    addWhiteList: "增加白名单",
    inputUrl: "请输入IP或IP地址段，例：192.168.1.1或192.168.1.0/24",
    inputRemark: "请输入描述",
    tableHeader: 'IP',
    logType1: 'ums',
    logType2: 'umsdevice',
    logType3: 'umswatch',
    logType4: 'umsmaintenance',
    logType5: 'mongod',
    logType6: 'mqtt',
     logType7:'others'
  },
  license: {
    license: "UC证书",
    licensebtn: "证书制作",
    creator: "制作人",
    orderno: "订单号",
    cicType: "证书类型",
    uc: "UC全功能版",
    zx: "直销版",
    bz: "标准版",
    ai: "AI版",
    createTitle: "请填写证书信息",
    inputOrderno: "请输入订单号",
    inputCic: "请选择证书类型",
    time: "制作时间",
    success: "制作成功",
    downLicense: "下载证书",
    inputMac: "请输入正确的设备MAC",
    count:"批量数量",
  },
  licenseOm8000: {
    standby: "主备",
    liuliang: "流量均衡许可数",
    licenseName: "设备证书",
    y: "年",
    m: "月",
    menuName: "设备证书",
    license: "证书制作",
    formbrand: "品牌",
    formproduct: "产品",
    form1: " 订单号",
    form2: "客户姓名",
    form3: "联系电话",
    form4: "客户公司名",
    form5: "备注",
    form31: "授权信息",
    form311: "分机授权",
    form3111: "设备MAC",
    form3112: "分机授权",
    form3113: "API授权",
    form3114: "PMS授权",
    form31121: "分机数",
    form31122: "手工输入",
    form3115: "有效期",
    form3116: "激活",
    form3117: "永久",
    form3118: "是否激活",
    form32: "HA证书",
    form321: "1#设备MAC",
    form322: "2#设备MAC",
    form323: "原功能证书设备MAC",
    rule1: "必填",
    rule2: "必须是整数",
    rule3: "至少激活一个授权信息或者HA证书",
    rule4: "HA证书至少输入一个mac地址",
    rule5: "请输入正确的号码",
    rule6: "请输入有效期",
    rule7: "1#设备mac和2#设备mac不能相同",
    search: "搜索",
    search1: "订单号",
    search2: "MAC",
    search3: "客户公司名",
    search4: "产品名",
    table1: "客户公司名",
    table2: "证书类型",
    machineCode: '机器码',
    cdrauthorization: 'CDR授权',
    lbauthorization: 'LB授权',
    oneMon: "一个月",
    threeMon: "三个月",
    halfYear: "半年",
    oneYear: "一年",
    secondYear: "两年",
    threeYear: "三年",
    tenYear: "十年",
    formOneMachine:'1号机MAC',
    formTwoMachine:'2号机MAC',
    haTips:"一套OM8000",
    standlyTips:'两套OM8000设备间互为主备',
    remotedisa:'异地容灾',
    limitTerminal:"可管理终端数",
    callAuth:"呼叫并发授权",
    meetAuth:"会议并发授权",
    voiceAuth:"语音信箱授权",
    extrecordAuth:"分机录音授权",
    centrexAuth:"Centrex授权",
    newlyncAuth:"Newlync接口授权",
    cloudAuth:"第三方Cloud接口授权",
    aiinterAuth:"AI接口授权",
    bookAuth:"通讯录管理授权",
    broadcastAuth:"广播/对讲授权",
    outrecordAuth:"外置录音接口授权",
    mastercluster:"主控集群容灾授权",
    mediaResource:"媒体资源集群容灾授权",
    dbcluster:"数据库集群容灾授权",
    concurrentAuth:"并发授权",
    terminalnumAuth:"终端授权",
    oneCode:'1号机机器码',
    twoCode:'2号机机器码',
    oldCode:'原功能证书设备机器码',
    mediaLabel:'媒体资源许可数',
    dbLabel:'数据库许可数',
    callLabel:'呼叫并发许可数',
    meetLabel:'会议并发许可数',
    voiceLabel:'语音信箱许可数',
    extrecordLabel:'分机录音许可数',
    dsAuth:'DS1授权',
	  dsLabel:'DS1许可数'

  },
  licenseUms: {
    menuName: "网管证书",
    inputTel: '请输入正确的联系电话',
    applyCode: '申请码',
    fun: '功能',
  },
  licenseNewlyncAS: {
    menuName: "Newlync应用服务证书",
  },
  licenseNewlync: {
    menuName: "NewLync证书",
    name:"客户姓名",
    phone:"手机",
    firename:"企业名称",
    address:"公司地址",
    remark:"备注",
    ldap:"通讯录功能",
    max_contacts:"最大人数",
    enableorN:"是否启用",
    activate:"启用",
    recording:"录音功能",
    max_record_conn:"录音最大并发数",
    cdr:"CDR功能",
    req_key:"授权请求key",
    expired:"有效期截止日志",
    features:"授权功能",
    visbel:"企业版本",
    cdr_fee:"CDR计费功能"

  },
  licenseRP: {
    menuName: "RMS 全录 PMSAPI",
  },
  licenseExpire: {
    menuName: "云平台穿透开通",
    phobne:"客户手机",
    company:"公司",
    address:"地址",
    type:"类型",
    expired:"有效期至",
    request_code:"申请码",
    typetile:"产品类型",
    expired1:"过期时间",
    email:"邮箱地址",
    release:"全录",
    nameTip:"请输入客户名称",
    expiredTip:"请选择日期",
    condition:"穿透开通状态",
    Active:"是否服务中",
    waringTip:"未开通或已过期",
    service:"服务中",
    notservice:"未服务"
  },
  licensethrough: {
    menuName: "授权过期预警",
    expiringdays:"即将过期天数",
    type:"类型",
    client:"客户",
    company:"公司名",
    expired:"过期时间",
    notify_count:"发送通知次数",
    agin:"重发预警邮件",
    send:"发送",
    renew:"续费",
    renewTip:"已续费",
  },
 licenseTLS:{
   menuName:"设备TLS证书"
 },
  neehau: {
    reportError: "侬好问题报告",
    neehauLog: "侬好日志",
    neehauStat: "侬好统计",
    appStat: "录音统计",
    devCount: "设备数",
    newDevCount: "新设备数",
    totalDevCount: "设备总数",
    topStat: "Top排行榜",
    loginnum: "登录次数",
    extcount: "活动分机数",
    rec_dur: "录音时长",

  },
  CodeData: {
    0: ["200", "成功", ""],
    1: ["200", "失败", ""],
    10000: ["400", "登录失败", "密码不对或帐号不存在"], // 100XX 用户或登录相关
    10001: ["403", "未登录", "没有登录或登录超时"],
    10002: ["403", "未授权", "证书无效或过期"],
    10003: ["403", "登录失败", "密码错误次数过多被锁定"],
    10004: ["403", "登录失败", "ip地址不在安全组，禁止登录"],
    10005: ["403", "权限不足", "禁止访问"],
    10006: ["403", "登录失败", "该账号被锁定，禁止登录"],
    10010: ["400", "新建用户失败", ""],
    10011: ["400", "新建用户失败", "缺少参数"],
    10012: ["400", "新建用户失败", "权限不够"],
    10013: ["400", "新建用户失败", "角色不存在"],
    10014: ["400", "新建用户失败", "用户帐号重复"],
    10015: ["400", "新建用户失败", "超级管理员角色不能分配"],
    10016: ["400", "新建用户失败", "域不存在"],
    10017: ["400", "新建用户失败", "电话格式不正确"],
    10020: ["400", "更新用户失败", "用户帐号不存在"],
    10021: ["400", "更新用户失败", ""],
    10022: ["400", "更新用户失败", "权限不足"],
    10023: ["400", "更新用户失败", "分配角色失败"],
    10024: ["400", "验证密码失败", "密码错误"],
    10025: ["400", "更新用户失败", "电话格式不正确"],
    10026: ["400", "更新用户失败", "邮件格式不正确"],
    10030: ["400", "获取用户失败", "用户帐号不存在"],
    10031: ["400", "获取用户失败", "权限不足"],
    10040: ["400", "删除用户失败", ""],
    10041: ["400", "删除用户失败", "系统用户不允许删除"],
    10042: ["400", "删除用户失败", "权限不足"],
    10050: ["400", "删除角色失败", ""],
    10051: ["400", "删除角色失败", "角色不存在"],
    10052: ["400", "删除角色失败", "系统角色不允许删除"],
    10053: ["400", "删除角色失败", "权限不足"],
    10054: ["400", "删除角色失败", "使用中"],
    10060: ["400", "更新角色失败", "角色不存在"],
    10061: ["400", "更新角色失败", ""],
    10062: ["400", "更新角色失败", "系统角色不允许修改"],
    10063: ["400", "更新角色失败", "权限不足"],
    10064: ["400", "更新角色失败", "权限参数无效"],
    10070: ["400", "新建角色失败", ""],
    10071: ["400", "新建角色失败", "缺少参数"],
    10072: ["400", "新建角色失败", "权限不足"],
    10073: ["400", "新建角色失败", "角色重复"],
    10074: ["400", "新建角色失败", "角色权限参数不正确"],
    10075: ["400", "新建角色失败", "角色参数不正确"],
    10076: ["400", "新建角色失败", "角色名称不正确"],
    10080: ["400", "获取角色失败", "角色不存在"],
    10081: ["400", "列出角色失败", ""],
    10082: ["400", "列出角色失败", "权限不足"],
    10091: ["400", "添加令牌失败", "权限不足"],
    10092: ["400", "修改令牌失败", "权限不足"],
    10093: ["400", "删除令牌失败", "权限不足"],
    10094: ["400", "删除令牌失败", "不存在"],
    10110: ["400", "获取配置失败", "自动发现令牌未配置"], // 101XX 系统配置相关
    10111: ["400", "配置发现令牌失败", "缺少参数"],
    10112: ["400", "配置发现令牌失败", ""],
    10113: ["400", "删除发现令牌失败", "未指定userid"],
    10114: ["400", "删除发现令牌失败", ""],
    10115: ["400", "修改发现令牌失败", "userid未找到"],
    10116: ["400", "修改发现令牌失败", "未指定userid"],
    10117: ["400", "配置发现令牌失败", "userid已存在"],
    10118: ["400", "配置发现令牌失败", "令牌不存在"],
    10119: ["400", "配置发现令牌失败", "令牌和用户名不匹配"],
    10120: ["400", "新建域失败", "权限不足"],
    10121: ["400", "新建域失败", "缺少参数"],
    10122: ["400", "新建域失败", ""],
    10123: ["400", "新建域失败", "域已存在"],
    10124: ["400", "新建域失败", "不能添加默认域"],
    10130: ["400", "更新域失败", "权限不足"],
    10131: ["400", "更新域失败", "域不存在"],
    10132: ["400", "更新域失败", ""],
    10133: ["400", "更新域失败", "域已存在"],
    10140: ["400", "删除域失败", "权限不足"],
    10141: ["400", "删除域失败", ""],
    10142: ["400", "删除域失败", "不存在"],
    10143: ["400", "删除域失败", "使用中"],
    10150: ["400", "获取域失败", "权限不足"],
    10151: ["400", "获取域失败", ""],
    10160: ["400", "删除分组失败", "未指定分组ID"],
    10161: ["400", "删除分组失败", "更新数据失败"],
    10162: ["400", "删除分组失败", "不允许删除默认分组"],
    10163: ["400", "删除分组失败", "分组不存在"],
    10164: ["400", "删除分组失败", "使用中"],
    10165: ["400", "修改分组失败", "缺少参数"],
    10166: ["400", "修改分组失败", "更新数据失败"],
    10167: ["400", "修改分组失败", "不允许修改默认分组"],
    10168: ["400", "修改分组失败", "分组信息未找到"],
    10170: ["400", "添加分组失败", "缺少参数"],
    10171: ["400", "添加分组失败", "更新数据失败"],
    10172: ["400", "添加分组失败", "不允许在默认分组中添加"],
    10173: ["400", "添加分组失败", "分组名不允许重复或使用默认名"],
    10180: ["400", "上传升级包失败", "未指定上传文件"],
    10181: ["400", "上传升级包失败", "存储失败"],
    10182: ["400", "修改升级包失败", "不存在"],
    10183: ["400", "删除升级包失败", "不存在"],
    10184: ["400", "查询升级包失败", "存储失败"],
    10185: ["400", "获取日志失败", "存储失败"],
    10186: ["400", "上传升级包失败", "文件名格式不对"],
    10187: ["400", "上传升级包失败", "基础版本错误"],
    10188: ["400", "不支持该版本的在线升级", "版本错误"],
    10189: ["400", "修改升级包失败", "基础版本错误"],
    10190: ["400", "上传文件失败", "未指定文件"],
    10191: ["400", "上传文件失败", "存取失败"],
    10192: ["400", "上传文件失败", "不支持该格式的文件"],
    10193: ["400", "获取日志失败", "权限不足"],
    10194: ["400", "获取日志失败", "对应的用户不存在"],
    10195: ["400", "上传升级包失败", "升级包已存在"],
    10196: ["400", "上传升级包失败", "同一个版本的升级包最多能上传两种"],
    10197: ["400", "操作升级包失败", "型号或版本错误"],
    10198: ["400", "操作升级包失败", "数据库错误"],
    10199: ["400", "列出升级包失败", "参数不正确"],
    10200: ["400", "导入证书失败", "未指定证书文件"],
    10201: ["400", "导入证书失败", "读取证书失败"],
    10202: ["400", "导入证书失败", "非法证书文件"],
    10203: ["400", "导入证书失败", "权限不够"],
    10210: ["400", "验证密码失败", "密码不正确"],
    10211: ["400", "验证密码失败", "设备不存在"],
    10212: ["400", "验证密码失败", "数据库错误"],
    10220: ["400", "新建访问ip列表失败", "缺少参数"],
    10221: ["400", "新建访问ip列表失败", "用户不存在"],
    10222: ["400", "新建访问ip列表失败", "权限不够"],
    10223: ["400", "新建访问ip列表失败", "数据库错误"],
    10224: ["400", "新建访问ip列表失败", "访问ip列表数量已达上限"],
    10230: ["400", "更新访问ip列表失败", "请求消息格式不正确"],
    10231: ["400", "更新访问ip列表失败", "用户不存在"],
    10232: ["400", "更新访问ip列表失败", "权限不够"],
    10233: ["400", "更新访问ip列表失败", "访问ip列表不存在"],
    10234: ["400", "更新访问ip列表失败", "数据库错误"],
    10235: ["400", "更新访问ip列表失败", "只能修改白名单"],
    10240: ["400", "删除访问ip列表失败", "请求消息格式不正确"],
    10241: ["400", "删除访问ip列表失败", "用户不存在"],
    10242: ["400", "删除访问ip列表失败", "权限不够"],
    10243: ["400", "删除访问ip列表失败", "访问ip列表不存在"],
    10244: ["400", "删除访问ip列表失败", "数据库错误"],
    10250: ["400", "列出访问ip列表失败", "请求消息格式不正确"],
    10251: ["400", "列出访问ip列表失败", "用户不存在"],
    10252: ["400", "列出访问ip列表失败", "权限不够"],
    10253: ["400", "列出访问ip列表失败", "访问ip列表不存在"],
    10254: ["400", "列出访问ip列表失败", "数据库错误"],
    10260: ["400", "增加基础版本失败", "请求消息格式不正确"],
    10261: ["400", "增加基础版本失败", "权限不足"],
    10262: ["400", "增加基础版本失败", "基础版本已存在"],
    10263: ["400", "增加基础版本失败", "数据库错误"],
    10264: ["400", "增加基础版本失败", "不支持该版本"],
    10270: ["400", "修改基础版本失败", "请求消息格式不正确"],
    10271: ["400", "增加基础版本失败", "权限不足"],
    10272: ["400", "修改基础版本失败", "基础版本不存在"],
    10273: ["400", "修改基础版本失败", "数据库错误"],
    10274: ["400", "修改基础版本失败", "不支持该版本"],
    10280: ["400", "删除基础版本失败", "请求消息格式不正确"],
    10281: ["400", "删除基础版本失败", "权限不足"],
    10282: ["400", "删除基础版本失败", "基础版本不存在"],
    10283: ["400", "删除基础版本失败", "数据库错误"],
    10290: ["400", "列出基础版本失败", "请求消息格式不正确"],
    10291: ["400", "列出基础版本失败", "基础版本不存在"],
    10292: ["400", "列出基础版本失败", "数据库错误"],
    10300: ["400", "权限不足", "设备不属于该用户设备组"],
    10310: ["400", "更新通知服务器失败", "数据库错误"],
    10311: ["400", "更新通知服务器用户失败", "数据库错误"],
    10312: ["400", "更新通知服务器密码失败", "数据库错误"],
    10313: ["400", "获取通知服务器信息失败", "数据库错误"],
    10314: ["400", "更新通知服务器失败", "权限不足"],
    10315: ["400", "获取通知服务器信息失败", "权限不足"],
    10316: ["400", "更新通知服务器语言失败", "数据库错误"],
    10320: ["400", "设置http服务失败", "请求消息格式不正确"],
    10321: ["400", "设置http服务失败", "数据库错误"],
    10322: ["400", "设置http服务失败", "权限不足"],
    10330: ["400", "设置ums配置失败", "请求消息格式不正确"],
    10331: ["400", "设置ums配置失败", "数据库错误"],
    10332: ["400", "设置ums配置失败", "权限不足"],
    10333: ["400", "设置ums配置失败", "设置的ip不是正确的ip地址"],
    10340: ["400", "获取ums配置失败", "请求消息格式不正确"],
    10341: ["400", "获取ums配置失败", "数据库错误"],
    10342: ["400", "获取ums配置失败", "权限不足"],
    10343: ["400", "设置访问设备白名单失败", "权限不足"],
    10344: ["400", "设置访问设备白名单失败", "缺少参数"],
    10345: ["400", "删除访问设备白名单失败", "权限不足"],
    10346: ["400", "删除访问设备白名单失败", "缺少参数"],
    10347: ["400", "设置访问设备白名单失败", "数据库错误"],
    10350: ["400", "修改参数失败", "权限不足"],
    10351: ["400", "修改模板失败", "权限不足"],
    10360: ["400", "升级检测失败", "权限不足"],
    10361: ["400", "升级检测失败", "未配置升级服务器"],
    10362: ["400", "升级检测失败", "获取升级服务器响应失败"],
    10370: ["400", "升级失败", "权限不足"],
    10371: ["400", "升级失败", "当前版本不需要升级"],
    10372: ["400", "升级失败", "升级错误"],
    10373: ["400", "升级失败", "下载安装包失败"],
    10374: ["400", "升级失败", "没有检测升级"],
    10375: ["400", "升级中", "不要重复执行升级"],
    10385: ["400", "修改升级包失败", "型号或版本错误"],
    10386: ["400", "修改升级包失败", "数据库错误"],
    10387: ["400", "删除升级包失败", "型号或版本错误"],
    10388: ["400", "删除升级包失败", "数据库错误"],
    10400: ["400", "通用", "请求消息格式不正确"],
    10401: ["400", "上传云组件失败", "未找到该型号对应的平台"],
    10402: ["400", "通用", "权限不足"],
    10410: ["400", "添加事件失败", "权限不足"],
    10411: ["400", "修改事件失败", "权限不足"],
    10412: ["400", "删除事件失败", "权限不足"],
    10413: ["400", "导出事件失败", "权限不足"],
    10420: ["400", "验证失败", "参数错误"],
    10421: ["400", "验证失败", "数据库错误"],
    10422: ["400", "验证失败", "权限不足"],
    10423: ["400", "验证不通过", "已被使用"],
    10424: ["400", "验证失败", "未知验证类型"],
    10425: ["400", "验证不通过", "不能以特殊字符开头"],
    10430: ["400", "删除升级包失败", "升级包在使用中，请先解除升级任务再删除"],
    10440: ["400", "增加强制升级选项失败", "请求消息格式不正确"],
    10441: ["400", "增加强制升级选项失败", "数据库错误"],
    10442: ["400", "增加强制升级选项失败", "权限不足"],
    10443: ["400", "增加强制升级选项失败", "已存在"],
    10444: ["400", "增加强制升级选项失败", "未找到对应的device_id"],
    10450: ["400", "删除强制升级选项失败", "请求消息格式不正确"],
    10451: ["400", "删除强制升级选项失败", "数据库错误"],
    10452: ["400", "删除强制升级选项失败", "权限不足"],
    10453: ["400", "删除强制升级选项失败", "不存在"],
    10454: ["400", "增加强制升级选项失败", "未找到对应的device_id"],
    10460: ["400", "查询设备失败", "请求消息格式不正确"],
    10461: ["400", "查询设备失败", "无效的mac地址"],
    10462: ["400", "查询设备失败", "获取设备失败"],
    10465: ["400", "设备诊断失败", "请求消息格式不正确"],
    10466: ["400", "设备诊断失败", "缺少device_id"],
    10467: ["400", "设备诊断失败", "未知操作"],
    10468: ["400", "设备诊断失败", "获取结果失败"],
    10470: ["400", "查询服务失败", "请求消息格式不正确"],
    10471: ["400", "查询服务失败", "获取服务失败"],
    10472: ["400", "查询服务失败", "设备未找到"],
    10475: ["400", "创建服务失败", "请求消息格式不正确"],
    10476: ["400", "创建服务失败", "创建失败"],
    10477: ["400", "创建服务失败", "设备未找到"],
    10478: ["400", "创建服务失败", "已存在"],
    10480: ["400", "删除服务失败", "请求消息格式不正确"],
    10481: ["400", "删除服务失败", "删除失败"],
    10482: ["400", "删除服务失败", "设备未找到"],
    10485: ["400", "上传日志失败", "请求消息格式不正确"],
    10486: ["400", "上传日志失败", "上传失败"],
    10487: ["400", "上传日志失败", "设备未找到"],
    10490: ["400", "查询P2P客户端失败", "请求消息格式不正确"],
    10491: ["400", "查询P2P客户端失败", "获取结果失败"],
    10495: ["400", "查询设备状态失败", "请求消息格式不正确"],
    10496: ["400", "查询设备状态失败", "获取结果失败"],
    10500: ["400", "上传全录日志失败", "非云平台设备"],
    10501: ["400", "上传全录日志失败", "设备不存在"],
    10502: ["400", "上传全录日志失败", "上传失败"],
    20000: ["400", "通用", "请求消息格式不正确"],
    20010: ["400", "添加设备失败", "请求消息格式不正确"],
    20011: ["400", "添加设备失败", "设备已存在"],
    20012: ["400", "添加设备失败", "数据库错误"],
    20013: ["400", "添加设备失败", "无效的mac地址"],
    20014: ["400", "添加设备失败", "设备数量已达到上限"],
    20015: ["400", "添加设备失败", "设备组不存在"],
    20016: ["400", "添加设备失败", "权限不足"],
    20020: ["400", "删除设备失败", "设备不存在"],
    20021: ["400", "删除设备失败", "缺少参数或数据库错误"],
    20022: ["400", "删除设备失败", "权限不足"],
    20030: ["400", "更新设备失败", "请求消息格式不正确"],
    20031: ["400", "更新设备失败", "设备不存在"],
    20032: ["400", "更新设备失败", "数据库错误"],
    20033: ["400", "更新设备连接状态失败", ""],
    20034: ["400", "更新设备", "获取或创建远程连接服务失败"],
    20035: ["400", "更新设备失败", "设备组不存在"],
    20036: ["400", "更新设备失败", "权限不足"],
    20037: ["400", "更新设备失败", "设备设置错误"],
    20040: ["400", "查看设备失败", "设备不存在"],
    20041: ["400", "查看设备失败", "权限不足"],
    20042: ["400", "查看设备上下线历史失败", "只支持连接到云平台的设备"],
    20043: ["400", "查看设备上下线历史失败", "查询失败"],
    20050: ["400", "查看设备列表失败", "请求消息格式不正确"],
    20051: ["400", "查看设备列表失败", "权限不足"],
    20060: ["400", "设备扫描失败", "请求消息格式不正确"],
    20061: ["400", "设备扫描失败", "获取设备失败"],
    20062: ["400", "设备扫描失败", "权限不足"],
    20063: ["400", "设备扫描失败", "正在扫描中"],
    20070: ["400", "导入设备失败", "请求消息格式不正确"],
    20071: ["400", "导入设备失败", "数据库错误"],
    20072: ["400", "导入设备失败", "设备数量超过500个，请到任务列表创建导入任务"],
    20073: ["400", "导入设备失败", "设备数量达到licence上限，部分设备导入失败"],
    20074: ["400", "导入设备失败", "权限不足"],
    20080: ["400", "导出设备失败", "请求消息格式不正确"],
    20081: ["400", "导出设备失败", "数据库错误"],
    20082: ["400", "导出设备失败", "权限不足"],
    20090: ["400", "导出设备状态失败", "请求消息格式不正确"],
    20091: ["400", "导出设备状态失败", "数据库错误"],
    20092: ["400", "导出设备状态失败", "权限不足"],
    20100: ["400", "设备tar包备份错误", "请求消息格式不正确"],
    20101: ["400", "设备tar包备份错误", "数据库错误"],
    20102: ["400", "设备tar包备份错误", "获取设备响应失败"],
    20103: ["400", "设备tar包备份错误", "备份失败，设备返回错误"],
    20104: ["400", "设备tar包备份失败", "权限不足"],
    20110: ["400", "设备tar包下发错误", "请求消息格式不正确"],
    20111: ["400", "设备tar包下发错误", "数据库错误"],
    20112: ["400", "设备tar包下发错误", "下发失败，服务器错误"],
    20113: ["400", "设备tar包下发错误", "下发失败，设备返回错误"],
    20114: ["400", "设备tar包下发错误", "获取设备响应失败"],
    20115: ["400", "设备tar包下发失败", "权限不足"],
    20120: ["400", "任务处理失败", "请求消息格式不正确"],
    20121: ["400", "任务处理失败", "缺少MAC地址"],
    20122: ["400", "任务处理失败", "缺少参数"],
    20123: ["400", "任务处理失败", "数据库错误"],
    20124: ["400", "任务处理失败", "模板不存在"],
    20125: ["400", "任务处理失败", "没有指定参数"],
    20126: ["400", "任务处理失败", "参数必须是一个整数"],
    20127: ["400", "任务处理失败", "未知的任务名"],
    20128: ["400", "任务处理失败", "权限不足"],
    20130: ["400", "任务查找失败", "数据库错误"],
    20140: ["400", "查看任务列表失败", "请求消息格式不正确"],
    20141: ["400", "查看任务列表失败", "权限不足"],
    20150: ["400", "查看参数库列表失败", "请求消息格式不正确"],
    20151: ["400", "查看参数失败", "参数不存在"],
    20160: ["400", "添加参数库失败", "缺少参数ID"],
    20161: ["400", "添加参数库失败", "参数已存在"],
    20162: ["400", "添加参数库失败", "型号不正确"],
    20170: ["400", "删除参数库失败", "请求消息格式不正确"],
    20171: ["400", "删除参数库失败", "数据库错误"],
    20172: ["400", "删除参数库失败", "参数库不存在"],
    20179: ["400", "下载日志失败", "权限不足"],
    20180: ["400", "下载日志失败", "请求消息格式不正确"],
    20181: ["400", "查看日志列表", "请求消息格式不正确"],
    20182: ["400", "下载运行日志失败", "请求消息格式不正确"],
    20183: ["400", "下载日志失败", "日志不存在"],
    20184: ["400", "下载日志失败", "未开启网络访问usb"],
    20185: ["400", "下载日志失败", "数据库错误"],
    20186: ["400", "下载日志失败", "设备返回错误"],
    20187: ["400", "下载日志失败", "获取设备响应失败"],
    20188: ["400", "下载日志失败", "下载日志不支持该型号的设备"],
    20189: ["400", "下载日志失败", "日期不能为今天或者未来"],
    20190: ["400", "更新参数失败", "请求消息格式不正确"],
    20191: ["400", "更新参数失败", "参数不存在"],
    20192: ["400", "更新参数失败", "数据库错误"],
    20193: ["400", "更新参数失败", "参数ID已存在"],
    20200: ["400", "查看话单失败", "请求消息格式不正确"],
    20201: ["400", "查看话单失败", "数据库错误"],
    20202: ["400", "话单导出失败", "数据库错误"],
    20210: ["400", "导入参数失败", "请求消息格式不正确"],
    20220: ["400", "配置对比失败", "请求消息格式不正确"],
    20221: ["400", "配置对比失败", "配置历史不存在"],
    20230: ["400", "添加模板失败", "缺少模板类型"],
    20231: ["400", "添加模板失败", "请求消息格式不正确"],
    20232: ["400", "添加模板失败", "数据库错误"],
    20233: ["400", "添加模板失败", "模板已存在"],
    20234: ["400", "新建配置失败", "配置已存在"],
    20235: ["400", "新建配置失败", "请求消息格式不正确"],
    20236: ["400", "新建配置失败", "数据库错误"],
    20237: ["400", "获取配置失败", "不存在或数据库错误"],
    20238: ["400", "获取部署历史失败", "不存在或数据库错误"],
    20239: ["400", "获取部署任务失败", "不存在或数据库错误"],
    20240: ["400", "获取模板失败", "模板不存在或数据库错误"],
    20241: ["400", "获取模板失败", "权限不足"],
    20242: ["400", "新建部署任务失败", "请求消息格式不正确"],
    20243: ["400", "更新部署任务失败", "请求消息格式不正确"],
    20244: ["400", "更新部署任务失败", "任务不存在"],
    20245: ["400", "获取号码资源失败", "不存在或数据库错误"],
    20246: ["400", "删除号码资源失败", "不存在或数据库错误"],
    20247: ["400", "新建号码资源失败", "请求消息格式不正确"],
    20248: ["400", "更新号码资源失败", "请求消息格式不正确"],
    20249: ["400", "更新号码资源失败", "号码资源不存在"],
    20250: ["400", "删除模板失败", "模板不存在"],
    20251: ["400", "删除模板失败", "数据库错误"],
    20252: ["400", "删除模板失败", "权限不足"],
    20253: ["400", "新建号码资源失败", "数据库错误"],
    20254: ["400", "新建号码资源失败", "号码或MAC重复"],
    20255: ["400", "更新号码资源失败", "号码或MAC重复"],
    20260: ["400", "更新模板失败", "请求消息格式不正确"],
    20261: ["400", "更新模板失败", "模板不存在"],
    20262: ["400", "更新模板失败", "数据库错误"],
    20263: ["400", "更新模板失败", "模板名重复"],
    20266: ["400", "更新模板失败", "权限不足"],
    20270: ["400", "恢复参数配置失败", "设备不存在"],
    20271: ["400", "恢复参数配置失败", "设备访问地址不存在"],
    20272: ["400", "恢复参数配置失败", "参数备份历史不存在"],
    20273: ["400", "恢复参数配置失败", "模板不存在"],
    20274: ["400", "恢复参数配置失败", "REST请求失败"],
    20275: ["400", "恢复参数配置失败", "缺少MAC地址信息"],
    20280: ["400", "任务更新失败", "请求消息格式不正确"],
    20281: ["400", "任务更新失败", "任务不存在"],
    20282: ["400", "任务更新失败", "一次性任务只能更新备注"],
    20283: ["400", "任务更新失败", "时间格式不正确"],
    20284: ["400", "任务更新失败", "数据库错误"],
    20285: ["400", "任务更新失败", "不能更新已取消的任务"],
    20286: ["400", "任务更新失败", "不能更新正在执行的任务"],
    20290: ["400", "更新参数备份历史失败", "参数备份历史数据不存在"],
    20291: ["400", "更新参数备份历史失败", "数据库错误"],
    20292: ["400", "更新参数备份历史失败", "请求消息格式不正确"],
    20300: ["400", "配置设备失败", "设备不可配置，无密码或url,或状态不对"],
    20301: ["400", "密码错误", "设备密码错误，请修改密码，或者刷新"],
    20302: ["400", "密码错误", "密码错误次数太多，10分钟内禁止访问"],
    20310: ["400", "修改备注失败", "请求消息格式不正确"],
    20311: ["400", "修改备注失败", "数据库错误"],
    20312: ["400", "修改备注失败", "记录不存在"],
    20320: ["400", "任务删除失败", "请求消息格式不正确"],
    20321: ["400", "任务删除失败", "任务不存在"],
    20322: ["400", "任务删除失败", "数据库错误"],
    20323: ["400", "任务删除失败", "只能删除已完成的任务"],
    20324: ["400", "任务删除失败", "权限不足"],
    20330: ["400", "清理数据失败", "请求消息格式不正确"],
    20331: ["400", "清理数据失败", "数据库错误"],
    20340: ["400", "备份数据失败", "请求消息格式不正确"],
    20341: ["400", "备份数据失败", "数据库错误"],
    20342: ["400", "不支持数据备份与恢复", "数据库与网管不在同一个机器上"],
    20350: ["400", "获取数据失败", "请求消息格式不正确"],
    20351: ["400", "获取数据失败", "数据库错误"],
    20360: ["400", "导出模板失败", "请求消息格式不正确"],
    20361: ["400", "导出模板失败", "数据库错误"],
    20370: ["400", "导入模板失败", "请求消息格式不正确"],
    20371: ["400", "导入模板失败", "数据库错误"],
    20380: ["400", "添加自动升级失败", "请求消息格式不正确"],
    20381: ["400", "添加自动升级失败", "数据库错误"],
    20390: ["400", "数据恢复失败", "请求消息格式不正确"],
    20391: ["400", "数据恢复失败", "数据库错误"],
    20400: ["400", "查看事件定义失败", "数据库错误"],
    20410: ["400", "删除事件定义失败", "事件定义不存在"],
    20411: ["400", "删除事件定义失败", "数据库错误"],
    20420: ["400", "添加事件定义失败", "请求消息格式不正确"],
    20421: ["400", "添加事件定义失败", "数据库错误"],
    20422: ["400", "添加事件定义失败", "事件已经存在"],
    20423: ["400", "导入事件失败", "数据库错误"],
    20424: ["400", "导出事件失败", "数据库错误"],
    20430: ["400", "更新事件定义失败", "请求消息格式不正确"],
    20431: ["400", "更新事件定义失败", "数据库错误"],
    20432: ["400", "更新事件定义失败", "事件定义不存在"],
    20440: ["400", "查看采集事件失败", "数据库错误"],
    20445: ["400", "更新采集事件失败", "不存在"],
    20446: ["400", "更新采集事件失败", "数据库错误"],
    20450: ["400", "更新设备事件开关失败", "请求消息格式不正确"],
    20451: ["400", "更新设备告警规则失败", "告警规则不存在"],
    20452: ["400", "更新设备事件开关失败", "设备配置失败"],
    20453: ["400", "更新设备告警规则失败", "请求消息格式不正确"],
    20454: ["400", "更新设备告警规则失败", "数据库错误"],
    20460: ["400", "权限不足", "设备不属于该用户"],
    20461: ["400", "失败", "设备不存在"],
    20462: ["400", "失败", "权限不足"],
    20470: ["400", "查看告警规则失败", "数据库错误"],
    20471: ["400", "添加告警规则失败", "请求消息格式不正确"],
    20472: ["400", "添加告警规则失败", "数据库错误"],
    20473: ["400", "获取告警规则失败", "数据库错误"],
    20474: ["400", "删除告警规则失败", "告警规则不存在"],
    20475: ["400", "删除告警规则失败", "数据库错误"],
    20476: ["400", "更新告警规则失败", "告警规则不存在"],
    20477: ["400", "更新告警规则失败", "请求消息格式不正确"],
    20478: ["400", "更新告警规则失败", "数据库错误"],
    20479: ["400", "删除告警规则失败", "告警规则正在使用中"],
    20480: ["400", "查看告警列表失败", "数据库错误"],
    20481: ["400", "获取告警信息失败", "数据库错误"],
    20482: ["400", "添加告警规则失败", "同一用户对同一事件只允许添加一条规则"],
    20483: ["400", "告警确认失败", "数据库错误"],
    20484: ["400", "告警确认失败", "告警不存在"],
    20485: ["400", "添加告警规则失败", "微信或邮件告警未授权"],
    20486: ["400", "更新告警规则失败", "微信或邮件告警未授权"],
    20487: ["400", "更新告警规则失败", "用户没有权限"],
    20488: ["400", "删除告警规则失败", "用户没有权限"],
    20490: ["400", "修改升级任务失败", "请求消息格式不正确"],
    20491: ["400", "修改升级任务失败", "数据库错误"],
    20492: ["400", "修改升级任务失败", "不能更新已取消的任务"],
    20493: ["400", "修改升级任务失败", "任务不存在"],
    20494: ["400", "修改升级任务失败", "只能停止未执行的任务"],
    20495: ["400", "删除升级任务失败", "请求消息格式不正确"],
    20496: ["400", "删除升级任务失败", "数据库错误"],
    20497: ["400", "删除升级任务失败", "只能删除已完成的任务"],
    20498: ["400", "删除升级任务失败", "任务不存在"],
    20499: ["400", "删除升级任务失败", "权限不足"],
    20500: ["400", "添加微信帐号失败", "获取微信用户信息失败"],
    20501: ["400", "添加微信帐号失败", "微信服务器错误"],
    20502: ["400", "添加微信帐号失败", "内部服务器通信错误"],
    20503: ["400", "添加微信帐号失败", "获取扫描用户失败"],
    20510: ["400", "访问设备受限，请将网管IP添加到云平台安全组"],
    20520: ["400", "创建配置文件模板失败", "请求消息格式不正确"],
    20521: ["400", "创建配置文件模板失败", "数据库错误"],
    20522: ["400", "创建配置文件模板失败", "获取设备响应失败"],
    20523: ["400", "创建配置文件模板失败", "备份失败，设备返回错误"],
    20524: ["400", "创建配置文件模板失败", "权限不足"],
    20525: ["400", "创建配置文件模板失败", "服务器错误"],
    20526: ["400", "创建配置文件模板失败", "模板名称已存在"],
    20530: ["400", "下发文件模板失败", "请求消息格式不正确"],
    20531: ["400", "下发文件模板失败", "数据库错误"],
    20532: ["400", "下发文件模板失败", "下发失败，服务器错误"],
    20533: ["400", "下发文件模板失败", "下发失败，设备返回错误"],
    20534: ["400", "下发文件模板失败", "获取设备响应失败"],
    20535: ["400", "下发文件模板失败", "权限不足"],
    20540: ["400", "修改配置文件模板失败", "请求消息格式不正确"],
    20541: ["400", "修改配置文件模板失败", "数据库错误"],
    20542: ["400", "修改配置文件模板失败", "模板不存在"],
    20543: ["400", "修改配置文件模板失败", "权限不足"],
    20544: ["400", "修改配置文件模板失败", "服务器错误"],
    20550: ["400", "删除配置文件模板失败", "请求消息格式不正确"],
    20551: ["400", "删除配置文件模板失败", "数据库错误"],
    20552: ["400", "删除配置文件模板失败", "模板不存在"],
    20553: ["400", "删除配置文件模板失败", "权限不足"],
    20560: ["400", "更新电话设置失败", "请求消息格式不正确"],
    20561: ["400", "更新电话设置失败", "数据库错误"],
    20562: ["400", "更新电话设置失败", "未开通"],
    20563: ["400", "更新电话设置失败", "权限不足"],
    20564: ["400", "更新电话设置失败", "禁止更新"],
    20570: ["400", "获取配置文件模板失败", "请求消息格式不正确"],
    20571: ["400", "获取配置文件模板失败", "数据库错误"],
    20572: ["400", "获取配置文件模板失败", "不存在"],
    20573: ["400", "获取配置文件模板失败", "权限不足"],
    20574: ["400", "获取配置文件模板失败", "服务器错误"],
    20580: ["400", "邮件服务器测试失败", "请求消息格式不正确"],
    20581: ["400", "邮件服务器测试失败", "账号无效，请输入完整的邮箱地址"],
    20582: ["400", "邮件服务器测试失败", "邮件服务器设置有误"],
    20583: ["400", "邮件服务器测试失败", "连接超时，地址错误或网络不可达"],
    20584: ["400", "邮件服务器测试失败", "密码未设置"],
    20585: ["400", "邮件服务器测试失败", "账号认证超时，账号或密码错误，或网络不可达"],
    20586: ["400", "邮件服务器测试失败", "账号认证失败，账号或密码错误"],
    20590: ["400", "更新通知服务器失败", "数据库错误"],
    20591: ["400", "更新通知服务器失败", "请求消息格式不正确"],
    20600: ["400", "删除参数备份记录失败", "请求消息格式不正确"],
    20601: ["400", "删除参数备份记录失败", "记录不存在"],
    20602: ["400", "删除参数备份记录失败", "数据库错误"],
    20605: ["400", "删除配置备份失败", "请求消息格式不正确"],
    20606: ["400", "删除配置备份失败", "记录不存在"],
    20607: ["400", "删除配置备份失败", "数据库错误"],
    20610: ["400", "删除日志备份备份失败", "请求消息格式不正确"],
    20611: ["400", "删除日志备份备份失败", "记录不存在"],
    20612: ["400", "删除日志备份备份失败", "数据库错误"],
    20620: ["400", "添加监控组失败", "请求消息格式不正确"],
    20621: ["400", "添加监控组失败", "数据库错误"],
    20622: ["400", "添加监控组失败", "已存在"],
    20623: ["400", "获取监控组失败", "不存在"],
    20624: ["400", "监控组类型不正确", "请求消息格式不正确"],
    20630: ["400", "删除监控组失败", "请求消息格式不正确"],
    20631: ["400", "删除监控组失败", "数据库错误"],
    20632: ["400", "删除监控组失败", "不存在"],
    20640: ["400", "更新监控组失败", "请求消息格式不正确"],
    20641: ["400", "更新监控组失败", "数据库错误"],
    20642: ["400", "更新监控组失败", "不存在"],
    20643: ["400", "更新监控组失败", "名称重复"],
    20650: ["400", "获取喂喂统计信息失败", "设备不存在"],
    20651: ["400", "获取喂喂统计信息失败", "获取失败"],
    20652: ["400", "获取喂喂统计信息失败", "缺少设备id或令牌信息"],
    20700: ["400", "修改配置失败", "请求消息格式不正确"],
    20701: ["400", "修改配置失败", "配置不存在"],
    30000: ["400", "通用", "请求消息格式不正确"],
    30020: ["400", "获取喂喂统计信息失败", "请求消息格式不正确"],
    30021: ["400", "获取喂喂统计信息失败", "获取失败"],
    30030: ["400", "获取统计日志失败", "请求消息格式不正确"],
    30031: ["400", "获取统计日志失败", "获取失败"],
    30032: ["400", "统计中", "不要重复执行"],
    30040: ["400", "删除全录日志失败", "请求消息格式不正确"],
    30041: ["400", "删除全录日志失败", "不存在"],
    30042: ["400", "删除全录日志失败", "数据库错误"],
    30050: ["400", "下载全录日志失败", "请求消息格式不正确"],
    30051: ["400", "下载全录日志失败", "数据库错误"],
    30052: ["400", "下载全录日志失败", "云平台上日志不存在"],
    30053: ["400", "下载中", "不要重复执行"],
    30060: ["400", "获取全录统计失败", "请求消息格式不正确"],
    30061: ["400", "获取全录统计失败", "数据库错误"],
    30070: ["400", "删除上报信息失败", "请求消息格式不正确"],
    30071: ["400", "删除上报信息失败", "不存在"],
    30072: ["400", "删除上报信息失败", "数据库错误"],
    30080: ["400", "获取应用列表失败", "请求消息格式不正确"],
    30081: ["400", "获取应用信息失败", "不存在"],
    30082: ["400", "获取应用信息失败", "数据库错误"],
    30090: ["400", "更新应用信息失败", "请求消息格式不正确"],
    30091: ["400", "更新应用信息失败", "不存在"],
    30092: ["400", "更新应用信息失败", "数据库错误"],
    30100: ["400", "删除应用信息失败", "请求消息格式不正确"],
    30101: ["400", "删除应用信息失败", "不存在"],
    30102: ["400", "删除应用信息失败", "数据库错误"],
    40000: ["400", "通用", "请求消息格式不正确"],
    40001: ["400", "失败", "不支持该诊断"],
    50000: ["400", "通用", "不支持该请求"],
    50001: ["400", "通用", "请求消息格式不正确"],
    50002: ["400", "通用", "缺少参数"],
    50003: ["400", "通用", "未授权操作"],
    2053: ["500", "处理超时", "内部错误"],
    2503: ["500", "处理超时", "内部错误"],
    20872: ["400", "添加大屏配置失败", "数据库错误"],
  },

  bigScreen: {
    'title': 'UMS系统监控大屏',
    'leftTopTitle': '使用占比',
    'leftTopItem1': '呼入并发',
    'leftTopItem2': '呼出并发',
    'leftTopItem3': '内部通话',
    'leftMiddleTitle': 'IP分机状态',
    'leftMiddleItem1': '在线数',
    'leftMiddleItem2': '离线数',
    'leftMiddleItem3': '注册异常',
    'leftBottomTitle': 'IP外线状态',
    'leftBottomItem1': '注册成功',
    'leftBottomItem2': '注册失败',
    'leftBottomItem3': '直连/未注册',
    'alarmNum': '实时并发总数',
    'CPU': 'CPU使用率',
    'RAM': 'RAM占有率',
    'LOCAL': '存储使用率',
    // 'centerBottomTitle': '下挂设备状态',
    'onlineDevice': '在线设备',
    'offlineDevice': '离线设备',
    'isdnCallStatisc': 'ISDN呼叫统计',
    'device': '设备',
    'bTotal': '并发总数',
    'deviceStatus': '下挂设备状态',
    'alarm': '警报',
    'peakCall': '通话并发峰值',
    "urgent": "紧急",
    "important": "重要",
    "generally": "一般",
    "addModalAddTitle": '请添加大屏配置',
    "modModalAddTitle": '请编辑大屏配置',
    "chartTypeLabel": '名称',
    "concurrencyStatistics": '并发统计',
    "alarmStatistics": '告警统计',
    "img": '图片',
    "device1": '1号机MAC',
    "device2": '2号机MAC',
    "hostInput": "请从列表中选择一个1号机",
    "slaveInput": "请从列表中选择一个2号机",
    "allDevice": '* 注： 所有设备',
    "tgDevice": '* 注： 所有TG设备',
    "preview": '预览',
    "confrimDel": '确定要删除该图表吗？',
    "sunday": "星期日",
    "monday": "星期一",
    "tuesday": "星期二",
    "wednesday": "星期三",
    "thursday": "星期四",
    "friday": "星期五",
    "saturday": "星期六",
    "template":"样图",
    "mainDevice":'主机',
    "standby":"备机",
    "workOrder":"工单",
    "workOrder1":"易迅工单",
    "serverUrl":'服务器地址',
    "inputServerUrl":'格式：http://ip:port',
    "addNum":"最多可以添加10组",
    "addTips":'最少添加一组设备',
    "addTips2":'1#MAC 不为空',
    "addTips3":'不能同时编辑多个设备组'
  },

  //--om/mx设备下发列表
  issueList: {
    issueStatus: '下发状态',
    issueMode: '下发模式',
    noConfig: '未配置',
    Config: '已配置',
    issued: '已发送',
    unissue: '未发送',
    theRemote: '远程',
    local: '本地'
  },

  ACSservice: {
    acsService: 'ACS服务',
    redirect: '自动管理',
    management_template: '模板管理',
    device_redirect: '设备自动管理',
    noConfig: '未配置',
    acsPath: 'ACS 地址',
    autoLabel1: '通过 DHCP option 66 获取 ACS 地址',
    autoLabel2: '固件更新',
    autoLabel3: '更新模式',
    autoLabel4: '更新周期',
    autoLabel5: '上电',
    autoLabel6: '上电+周期',
    autoLabel7: '秒（范围： 5~86400 ）',
    autoLabel8: '例：protocol://211.168.5.153，protocol：http，https，tftp，ftp',
    acsLabel1: "模式：",
    acsLabel2: "用户名：",
    acsLabel3: "密码：",
    acsLabel4: "端口：",
    acsLabel5: "路径：",
    saveSuccess: '保存成功',
    addTemplate: '请输入模板信息',
    selectMode: '请选择更新模式',
    templateTab1: '模板名称',
    templateTab2: '备注',
    templateTab3: '模板名称',
    delSuccess: '删除模板成功',
    addTempSuccess: '创建模板成功',
    modTempSuccess: '修改模板成功',
    msg1: '请输入模板名称',
    msg2: '更新周期必须为数字值',
    msg3: '更新周期范围值为5~86400',
    msg4: '请输入模板备注',
    msg5: '请输入ACS地址',
    autoDeviceTemplate: '模板',
    selectTemplate: '请选择自定义模板',
    tips: '角色为默认时，创建域管理员',
    default: '默认',
    noexist: '（已删除）',
    allDomain: '所有域'
  },
  metaprofile: {
    metaprofileMenu: '自定义模板',
    functionType: '功能',
    templateConfig: '模板配置',
    baseInfo: '基础信息',
    paramList: "参数列表",
    nextStep: '下一步',
    prevStep: '上一步',
    msg1: '暂不支持该参数',
    confrimInfo: '确认信息',
    addParamsInfo: '点击参数列表前方加号添加参数模板',
    addErrorMsg: '参数列表已存在',
    switchTip: '* 切换操作将会清除已添加的参数列表',
    msg2: '参数列表不能为空',
    msg3: '* 没有选择域，表示所有域。',
    msg4: '* 值为null， 则设备与模板解除绑定',
    msg5: '请在参数列表中设置参数显示'
  },
  sysmonitor: {
    headerTitle: '系统告警通知',
    monitorMessage: '自定义消息：',
    confirmDelWechats: "删除成功后，系统告警信息不再通知该微信"

  },

  message: {
    msg1: "请至少选择一个分组"
  },

  appStat: {
    active: '活跃度',
    recordData: '录音数据',
    quantity: '数量',
    activeBoard: '活跃度排行榜'
  },
  actomDetail: {
    registered: '已注册',
    accountActive: '账号激活',
    actomDetail: '禁用',
    formLabelTag: '显示标签',
    formLabelName: '显示名字',
    registName: '认证名称',
    userName: '用户名称',
    sipServer: 'SIP备份服务器',
    outbound: 'Outbound 代理',
    dtmfType: 'DTMF 类型',
    subscription: '订阅周期（秒）',
    localsipPort: '本地SIP端口',
    timeOut: '超时（秒）',
    udpTime: 'UDP保活消息发送间隔（秒）',
    udpMsg: 'UDP保活消息',
    stunServer: 'STUN服务器',
    nat: 'NAT穿透',
    tlsVersion: 'TLS版本',
    outboundStatus: 'Outbound 状态',
    unregistMode: '非注册拨打模式',
    transport: '传输方式',
    account1: '账号 1',
    account2: '账号 2',
    account3: '账号 3',
    account4: '账号 4',
    account5: '账号 5',
    account6: '账号 6',
    nomodify: '没有修改',
    ipphoneBusy: '话机繁忙',
    saveFail: '保存失败',
    disableEncoding: '停用编码',
    enableEncoding: '启用编码',
    callForwarding: '呼叫转移',
    callNum: '呼叫转移紧急号码',
    callForwardnum: '呼叫转移鉴权号码',
    model: '模式',
    transfer: '无条件转移',
    nodisOff: '免打扰关闭特征码',
    nodisOn: '免打扰开启特征码',
    offCode: '关闭特征码',
    onCode: '开启特征码',
    targetNum: '目标号码',
    nodisStauts: '免打扰状态',
    ipphone: '话机',
    nodisnum: '免打扰鉴权号码',
    nodisNum1: '免打扰紧急号码',
    busyTransfer: '遇忙转移',
    replaceRule: '替换规则',
    prefix: '前缀',
    replace: '替换',
    application: '应用',
    immediatelyCall: '立即呼出',
    lcode: '地区代码',
    areaCode: '区号',
    minlen: '最小长度',
    maxLen: '最大长度',
    exhaleLimit: '呼出限制',
    limitNum: '限制呼出号码',
    selectDel: '请选择要删除的数据',
    tip1: '前缀和替换为不可为空',
    tip2: '立即呼出不可为空',
    errMsg1: '最小值范围错误',
    errMsg2: '最大值范围错误',
    errFile: '无效文件',
    uploadOneFile: '一次只能上传一个文件',
    uploadCfg: '请上传cfg格式的文件',
    exportFile: '导入/导出CFG文件',
    clickUpload: '点击上传',
    clickUpload1: '点击获取文件后选择需要上传的文件',
    exportSysLog: '导出系统日志',
    fatalError: '致命错误',
    warning: '警告',
    info: '信息',
    debug: '调试',
    server: '服务器',
    logArea: '日志位置',
    serverName: '服务器名称',
    callfun: '电话功能设定', //ipphone
    dialPlan: '收号规则',
    codecSet: '媒体设置',
    sysConfig: '系统配置',
    confirmReboot: '"确定要重启？',
    rebootSuccess: '重启成功',
    rebootFail: '重启失败',
    modNot: '不修改密码无需填写',
    softwareVersion: '软件版本号',
    hardwareVersion: '硬件版本号',
    codec: '编解码',
    dialingRules: '拨号规则',
    staticsChart: '这里放统计图',
    detailList: '这里放详细列表',
    delLicense: '确定要删除 {name} 证书？',
    operationCodeRequired: '操作码必填',
    testInterval: '测试间隔',
    testNum: '测试次数',
    successNum: '成功次数',
    failNum: '失败次数',
    counts: '次数',
    completeTime: '完成时间',
    askCancel: "确定要取消任务？ 是否继续？",
    cancelSucess: '取消成功',
    execuNum: '执行次数',
    validate1: '只包含数字和小数点',
    validate2: '格式不正确',
    cloneing: '正在克隆，请稍等...',
    config: '配置',
    inputconfigName: '请输入配置文件名称',
    configNull: '配置不能为空',
    modCycle: '更改更新周期',
    tokenverify:"验证模式",
    tokenmode:"token验证模式"
  },

  ipphoneInfo: {
    callWait: '开启呼叫等待',
    callForward: '允许呼叫转移',
    halfForward: '允许半出席转',
    threeMetting: '允许三路会议',
    standby: '通话结束自动回到待机',
    autohangup: '自动挂机时间',
    silentMode: '启动静音模式',
    silentRing: '禁止铃声静音',
    defaultLine: '开启默认线',
    autoSwitchLine: '开启自动切换线路',
    defaultOutLine: '默认呼叫外线',
    disableOutbount: '禁止呼出',
    hiddenDtmf: '隐藏DTMF',
    saveCallhistory: '保存通话记录',
    enablelimitList: '启用限制来电名单',
    enablecallList1: '启用允许来电名单',
    enablecallList2: '启用限制拨出名单',
    enableCountryCode: '启用国家码',
    countryCode: '国家码',
    stop: '已停用',
    delay: '延期',
    endShow: '末尾显示',
    enableNumprivacy: '启用号码隐私',
    matchDirection: '匹配方向',
    leftToRight: '从左往右',
    rightToLeft: '从右往左',
    startPosition: '开始位置',
    hiddenBits: '隐藏位数',
    allowIPCall: '允许IP呼叫',
    firstCallerName: '主叫名称显示优先级',
    sipName1: '本地电话本-网络电话本-sip 显示名称',
    sipName2: '本地电话本-sip 显示名称-网络电话本',
    sipName3: '网络电话本-本地电话本-sip 显示名称',
    sipName4: '网络电话本-sip 显示名称-本地电话本',
    sipName5: 'sip 显示名称-本地电话本-网络电话本',
    sipName6: 'sip显示名称-网络电话本-本地电话本',
    emergencyNumber: '紧急呼叫号码',
    searchScope: '联系人搜索范围',
    localConcat: '仅限本地联系人',
    ldapLocal: 'ldap 和 本地联系人',
    ldapSearch: 'ldap 搜索',
    callerModel: '主叫信息显示方式',
    firstDisplayName: '优先显示姓名',
    onlyNum: '只显示号码',
    displayEmpty: '显示空白',
    normal: '正常的',
    limitActive: '限制Active URI来源IP',
    XMLServerUrl: 'XML推送服务器地址',
    allowPredial: '允许预拨号',
    onMultiLine: '开启Multi Line',
    customLineformat: '自定义线路格式',
    whiteListType: '本地联系人作为白名单的类型',
    dialnumber: '按#键拨出号码',
    lenDailNum: '固定长度拨号',
    fixedLength: '固定长度',
    endTransfer: '以#结尾盲转',
    hangBlind: '挂机盲转',
    hangOutBlind: '挂机出席转',
    threeTransfer: '三方挂机出席转',
    enablee: '启用 E.164',
    timeOutDail: '超时拨号',
    miao330: ' 秒（3~30）',
    dial: '拨号',
    proxyServerIp1: '代理服务器地址',
    proxyServerIp2: '备份代理服务器地址',
    proxyServerPort1: '代理服务器端口',
    proxyServerPort2: '备份代理服务器端口',
    proxyUser: '代理用户',
    proxyPass: '代理密码',
    userAuth: '用户认证',
    verificationPass: '验证密码',
    registrationValidity: '注册有效期',
    serverIP: '服务器地址',
    serverPort: '服务器端口',
    transportProtocol: '传输协议',
    exportConfig: '导出配置',
    importConfig: '导入配置',
    txtConfig: 'txt配置',
    ncConfig: 'nc配置',
    xmlConfig: 'XML配置',
    onSyslog: '开启系统日志',
    syslogServerIP: '系统日志服务器地址',
    syslogServerPort: '系统日志服务器端口',
    syslogLevel: '系统日志级别',
    exportLog: '导出日志',
    factory: '厂家',
    serialNum: '序列号',
    unuseMemory: '剩余内存',
    residualFlash: '剩余Flash',
    runningTime: '运行时长',
  },
  monitorPage:{
    'modalTitle':'请添加设备',
    'normal':'正常',
    'unConnected':'未连接',
    'macAddress':'MAC地址：',
    'line1':'线路1',
    'line2':'线路2',
    'line3':'线路3',
    'line4':'线路4',
    'alarmNum':"当前有 {num} 条警报",
    'goAdd':"当前暂未添加设备，请前去添加",
    'frontPanel':"前面板",
    'rearPanel':"后面板",
    'chassis1':"机箱号",
    // 'chassis2':"机箱号",
    'fan':"风扇",
    'fault':"故障",
    'disableManually':"手动停用",
    'working':"工作中",
    'standing':"待命中",
    'cidShow':"CID显示：",
    'isdnStatus':"ISDN线路状态图",
    'tip1':'注：后面板中的两个AUX接口互通，两灯状态同时修改',
    'lost':'丢失',
    'wareLost':'硬件配置缺失',
    'status':'状态：',
    'deviceMode':'设备模式：',
    'disabled':'未启用',
    'active':'激活',
    'standby':'备用',
    'error':'运行出错',
    'waiting':'等待',
    'primary':'主设备',
    'secondary':'从设备',

  },
  sbcConf:{
    itspServer:'软交换',
    serverPort:'服务端口',
    seq:'序号',
    response:'朝对方发送端口回复',
    yes:'是',
    no:'否',
    netPort1:'网口1',
    netPort2:'网口2',
    netPort3:'网口3',
    netPort4:'网口4',
    port:'端口',
    itspSeq:'软交换序号',
    backupSwitch1:'备份软交换一',
    backupSwitch2:'备份软交换二',
    voiceEncryption:'语音加密',
    encryption:'加密方式',
    encryptionKey:'加密密钥',
    null:'无',
    telnetServer:'Telnet服务',
    sshServer:'SSH服务',
    telsshPass:'Telnet/SSH服务密码',
    itspMsg1:'设备重启后配置生效',
    itspMsg2:'配置格式错误',
    itspMsg3:'配置保存失败',
    itspMsg4:'获取数据失败',
    itspMsg5:'至少 8 个字符，必须是字母、数字或符号的组合（&，%除外）',
    itspMsg6:'保存失败',
    itspMsg7:'保存成功',
  },
  server:{
    management_police:'话单管理',
    serverConfig:'推送配置',
    serverAddrs:'平台地址',
    serverType:'平台类型',
    serverInfo:'平台信息',
    grant_type:'客户端类型',
    client_id:'客户端Id',
    LoginType:'登录类型',
    Client_secret:'密码',
    inputaddr:"请输入平台地址",
    inputpol:'域名：端口，如192.168.120.20:8080',
    call_record:"通话记录",
    serverTypevalue:'大连警务',
    serverjh:'金华警务',
    ip:'IP',
    IC:"内部呼叫（IP到FXS）",
    internal_call:'内部呼叫（FXS到IP）',
    IP:"不明呼叫",
    calltype:"呼叫类型",
    trunkNumber:'中继号',
    router:"路由",
    sipproxy:"代理服务器",
    firmware:"版本信息",
    sipregistration:'注册服务器',
    datetime:"日期时间",
    timerange:"选择时间范围",
    query:'主叫、被叫、中继号',
    cpnIP:"主叫IP",
    udpadrrconfig:'话单收集配置',
    localudpaddr:'本地监听端口',
    extranet:"外网地址",
    deletetip:"请输入设备MAC地址或者选择日期范围。",
    routeip:"IP中继",
    routexo:"FXO模拟中继",
    success:"提交成功，请重启",
    device_IP:"设备外网IP",
    deviceInf:"设备信息",
    lastcontacttime:"最后更新时间",
    downloadLog:"下载日志",
    logtitle:"日志列表",
    deviceconfig:"设备配置",
    issuetitle:"下发列表",
    issuenowtime:"下发实际时间",
    issuesettime:"web下发时间",
    issuecontent:"下发内容",
    callenable:"允许呼叫",
    forbiddenCall:"禁止呼叫",
    calltitle:"呼叫",
    recordcheck:"开启录音",
    downrecord:"下载录音",
    callverify:"确定要呼叫该被叫号码吗？",
    calltip:"请输入被叫号码",
    logtype:"日志类型",
    recordlog:"录音日志",
    log:"日志",
    operationTip:"命令",
    waringTip:"，请稍后再操作",
    nosend:"未发送",
    sending:"发送中",
    caleer:"被叫号码",
    dellog:"请选择日志"
  }

};



// WEBPACK FOOTER //
// ./src/lang/zh-cn.js